(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./routes/areas/areas.module": "./src/app/routes/areas/areas.module.ts",
	"./routes/buildings/buildings.module": "./src/app/routes/buildings/buildings.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n\n<div [class.example-is-mobile]=\"mobileQuery.matches\">\n  <mat-sidenav-container [style.marginTop.px]=\"mobileQuery.matches ? 56 : 0\" fullscreen>\n    <mat-sidenav #snav [mode]=\"mobileQuery.matches ? 'over' : 'side'\" [fixedInViewport]=\"mobileQuery.matches\" fixedTopGap=\"56\">\n      <mat-list *ngIf=\"isLoggedIn()\">\n\n\n        <mat-list-item>\n        <button mat-button routerLink=\"/\" routerLinkActive>\n          <mat-icon>school</mat-icon>\n          Nástěnka\n        </button>\n      </mat-list-item>\n\n        <mat-list-item>\n          <button mat-button routerLink=\"/areas\" routerLinkActive>\n            <mat-icon>gps_fixed</mat-icon>\n            Oblasti\n          </button>\n        </mat-list-item>\n\n\n        <mat-list-item>\n        <button mat-button routerLink=\"/buildings\" routerLinkActive>\n          <mat-icon>business</mat-icon>\n          Objekty\n        </button>\n      </mat-list-item>\n\n\n      <mat-list-item>\n        <button mat-button (click)=\"createBackup()\" >\n          <mat-icon>cloud_download</mat-icon>\n          Vytvoření zálohy\n        </button>\n      </mat-list-item>\n\n<!--        <mat-list-item>-->\n<!--          <button mat-button routerLink=\"/users\" routerLinkActive>-->\n<!--            <mat-icon>face</mat-icon>-->\n<!--            Uživatelé-->\n<!--          </button>-->\n<!--        </mat-list-item>-->\n\n          <mat-list-item>\n            <button mat-button (click)=\"downloadAPK('1.1')\" >\n              <mat-icon>arrow_downward</mat-icon>\n              Stáhnout aplikaci <span style=\"font-size: 10px;\"> v1.1</span>\n            </button>\n          </mat-list-item>\n\n\n        <mat-list-item>\n            <button mat-button (click)=\"downloadAPK('1.2')\" >\n              <mat-icon>arrow_downward</mat-icon>\n              Stáhnout aplikaci <span style=\"font-size: 10px;\"> v1.2</span>\n            </button>\n        </mat-list-item>\n\n\n\n        <mat-list-item>\n          <button mat-button (click)=\"logout()\" routerLinkActive>\n            <mat-icon>settings_power</mat-icon>\n            Odhlásit se\n          </button>\n        </mat-list-item>\n\n      </mat-list>\n    </mat-sidenav>\n\n    <mat-sidenav-content>\n        <mat-toolbar>\n          <button *ngIf=\"isLoggedIn()\" mat-icon-button (click)=\"snav.toggle()\"><mat-icon>menu</mat-icon></button>\n          <img src=\"../assets/images/logo_ose_white.png\" width=\"219\" height=\"33\" />\n        </mat-toolbar>\n      <div class=\"app-padding\">\n        <router-outlet></router-outlet>\n      </div>\n    </mat-sidenav-content>\n  </mat-sidenav-container>\n\n\n  </div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/add-area/add-area.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/add-area/add-area.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-horizontal-stepper [linear]=\"true\" #stepper>\n    <mat-step [stepControl]=\"firstFormGroup\">\n        <form [formGroup]=\"firstFormGroup\">\n            <ng-template matStepLabel>Název oblasti</ng-template>\n            <mat-form-field>\n                <input matInput placeholder=\"Zadejte název oblasti\" formControlName=\"name\" required>\n            </mat-form-field>\n            <br>\n            <mat-form-field>\n                <input matInput placeholder=\"Zadejte název PIN kód\" formControlName=\"pin\" required>\n<!--                <div *ngIf=\"_formBuilder.control('pin').errors\" class=\"invalid-feedback\">-->\n<!--                    <div *ngIf=\"_formBuilder.control('pin').errors.required\">Pin is required</div>-->\n<!--                </div>-->\n            </mat-form-field>\n\n            <div>\n                <button mat-button matStepperNext>Další</button>\n            </div>\n        </form>\n    </mat-step>\n    <mat-step>\n        <form>\n            <ng-template matStepLabel>Vyberte oblast</ng-template>\n\n            <button mat-button matStepperPrevious>Zpět</button>\n\n            <button matStepperNext (click)=\"savePolygon()\" type=\"button\" mat-button>\n                <mat-icon>save</mat-icon>\n                Uložit oblast\n            </button>\n            <agm-map [latitude]=\"lat\" [longitude]=\"lng\" (mapReady)=\"onMapReady($event)\" ></agm-map>\n        </form>\n    </mat-step>\n    <mat-step>\n        <ng-template matStepLabel>Shrnutí</ng-template>\n\n        <div *ngIf=\"loading; else finished\" style=\"display: flex; justify-content: center; align-items: center\">\n            <mat-spinner></mat-spinner>\n        </div>\n        <ng-template #finished>\n\n            <h1>Do oblasti bylo přidáno {{buildingsCount}} objektů</h1>\n            <p>Budete přesměrováni za 5s</p>\n        </ng-template>\n\n        <div>\n<!--            <button mat-button matStepperPrevious>Zpět</button>-->\n<!--            <button mat-button (click)=\"stepper.reset()\">Reset</button>-->\n        </div>\n    </mat-step>\n</mat-horizontal-stepper>\n\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/areas.component.html":
/*!*****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/areas.component.html ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"success\" role=\"header\" class=\"primary-toolbar\">\n    <div fxflex=\"50px\" style=\"flex: 1 1 50px; box-sizing: border-box; max-width: 50px; min-width: 50px;\" ng-reflect-flex=\"50px\">\n        <button type=\"button\" class=\"menu-btn\" mat-icon-button>\n            <mat-icon>gps_fixed</mat-icon>\n        </button>\n\n    </div>\n    <div style=\"flex: 1 1 100px;box-sizing: border-box;max-width: 100px;min-width: 100px;\"> Oblast </div>\n\n\n\n    <button  matTooltip=\"Přidat oblast\" type=\"button\" routerLink=\"add\" class=\"menu-btn\" mat-icon-button>\n        <mat-icon>add</mat-icon>\n    </button>\n\n\n    <button matTooltip=\"Zobrazit polygony\" type=\"button\" routerLink=\"show\" class=\"menu-btn\" mat-icon-button>\n        <mat-icon>map</mat-icon>\n    </button>\n\n    <span class=\"fill-space\"></span>\n\n    <mat-form-field style=\"font-size:13px;\">\n        <input matInput type=\"text\" (keyup)=\"doFilter($event.target.value)\" placeholder=\"Vyhledat\">\n    </mat-form-field>\n</mat-toolbar>\n\n<table mat-table [dataSource]=\"dataSource\" class=\"mat-elevation-z8\">\n\n\n    <!-- Position Column -->\n    <ng-container matColumnDef=\"pin\">\n        <th mat-header-cell *matHeaderCellDef>PIN</th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.pin}}\n        </td>\n    </ng-container>\n\n\n    <!-- Position Column -->\n    <ng-container matColumnDef=\"name\">\n        <th mat-header-cell *matHeaderCellDef>Název</th>\n        <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\n    </ng-container>\n\n    <!-- Weight Column -->\n    <ng-container matColumnDef=\"action\">\n        <th mat-header-cell *matHeaderCellDef> Akce </th>\n        <td mat-cell *matCellDef=\"let element\">\n\n                <button routerLink=\"edit/{{element.id}}\" matTooltip=\"Zobrazit oblast\" mat-icon-button>\n                    <mat-icon>arrow_right_alt</mat-icon>\n                </button>\n                <button (click)=\"confirmDelete(element.id, element.name)\" matTooltip=\"Smazat oblast\" mat-icon-button>\n                    <mat-icon>delete</mat-icon>\n                </button>\n\n\n        </td>\n    </ng-container>\n\n\n    <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n    <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n</table>\n\n<div *ngIf=\"loading\" style=\"display: flex; justify-content: center; align-items: center\">\n    <mat-spinner></mat-spinner>\n</div>\n\n<mat-paginator [pageIndex]=0 [pageSize]=\"50\" showFirstLastButtons></mat-paginator>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/edit-area/edit-area.component.html":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/edit-area/edit-area.component.html ***!
  \*******************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"success\" role=\"header\" class=\"primary-toolbar\">\n    <div fxflex=\"50px\" style=\"flex: 1 1 50px; box-sizing: border-box; max-width: 50px; min-width: 50px;\" ng-reflect-flex=\"50px\">\n        <button routerLink=\"/areas\" routerLinkActive type=\"button\" class=\"menu-btn\" mat-icon-button>\n            <mat-icon>gps_fixed</mat-icon>\n        </button>\n\n    </div>\n    <div style=\"flex: 1 1 100px;box-sizing: border-box;max-width: 100px;min-width: 100px;\"> Upravení oblasti </div>\n</mat-toolbar>\n\n<form [formGroup]=\"formGroup\" style=\"padding:10px;\">\n    <ng-template matStepLabel>Název oblasti</ng-template>\n    <mat-form-field style=\"margin-right:20px;\">\n        <input matInput placeholder=\"Zadejte název oblasti\" formControlName=\"name\" required>\n    </mat-form-field>\n\n    <mat-form-field style=\"margin-left:20px;margin-right:20px;\">\n        <input matInput placeholder=\"Zadejte název PIN kód\" formControlName=\"pin\" required>\n    </mat-form-field>\n\n    <button (click)=\"saveArea()\" mat-button>\n    <span *ngIf=\"loading;\" style=\"width:10px; height: 10px;\">  <mat-spinner></mat-spinner></span> Uložit </button>\n\n</form>\n\n<agm-map [latitude]=\"lat\" [longitude]=\"lng\" [zoom]=\"12\" (mapReady)=\"onMapReady($event)\" ></agm-map>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/show-areas/show-areas.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/show-areas/show-areas.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"success\" role=\"header\" class=\"primary-toolbar\">\n    <div fxflex=\"50px\" style=\"flex: 1 1 50px; box-sizing: border-box; max-width: 50px; min-width: 50px;\" ng-reflect-flex=\"50px\">\n        <button routerLink=\"/areas\" routerLinkActive type=\"button\" class=\"menu-btn\" mat-icon-button>\n            <mat-icon>gps_fixed</mat-icon>\n        </button>\n\n    </div>\n    <div style=\"flex: 1 1 100px;box-sizing: border-box;max-width: 100px;min-width: 100px;\"> Zobrazení oblastí </div>\n</mat-toolbar>\n\n<agm-map [latitude]=\"lat\" [longitude]=\"lng\" (mapReady)=\"onMapReady($event)\" ></agm-map>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/add-building/add-building.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/add-building/add-building.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"formGroup\" (ngSubmit)=\"onSubmit(formGroup.value)\">\n\n\n    <mat-form-field>\n        <input matInput placeholder=\"Zadejte název\" formControlName=\"name\" required>\n    </mat-form-field>\n    <br>\n    <mat-form-field>\n        <input matInput placeholder=\"Zadejte kód objektu\" formControlName=\"building_code\" required>\n    </mat-form-field>\n\n    <br>\n    <div *ngIf=\"errorMessage\" style=\"padding:4px; color: red;\">\n        {{errorMessage}}\n    </div>\n\n    <button mat-raised-button (click)=\"dialogRef.close(false)\">Zrušit</button>\n        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;\n    <button mat-button type=\"submit\" [disabled]=\"formGroup.invalid\">\n        Přidat\n    </button>\n\n</form>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/buildings.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/buildings.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"success\" role=\"header\" class=\"primary-toolbar\">\n    <div fxflex=\"50px\" style=\"flex: 1 1 50px; box-sizing: border-box; max-width: 50px; min-width: 50px;\" ng-reflect-flex=\"50px\">\n        <button type=\"button\" class=\"menu-btn\" mat-icon-button>\n            <mat-icon>business</mat-icon>\n        </button>\n\n    </div>\n    <div style=\"flex: 1 1 100px;box-sizing: border-box;max-width: 100px;min-width: 100px;\"> Objekty </div>\n\n    <button  (click)=\"addBuilding()\" matTooltip=\"Přidat objekt\" type=\"button\"  class=\"menu-btn\" mat-icon-button>\n        <mat-icon>add</mat-icon>\n    </button>\n\n    <!-- This fills the remaining space of the current row -->\n    <span class=\"fill-space\"></span>\n\n    <mat-form-field style=\"font-size:13px; margin-top:10px; margin-right:20px;\">\n            <mat-label>Vyberte oblast</mat-label>\n            <mat-select (selectionChange)=\"areaFilter($event)\">\n                <mat-option [value]=\"\">\n                    Všechny oblasti\n                </mat-option>\n                <mat-option *ngFor=\"let area of areas\" [value]=\"area.id\">\n                    {{area.name}}\n                </mat-option>\n            </mat-select>\n    </mat-form-field>\n\n    <mat-form-field style=\"font-size:13px; margin-top:10px;\">\n        <input matInput type=\"text\" (keyup)=\"fullTextSearch($event.target.value)\" placeholder=\"Vyhledat\">\n    </mat-form-field>\n\n</mat-toolbar>\n<mat-progress-bar *ngIf=\"progressBar\" mode=\"query\"></mat-progress-bar>\n\n<table mat-table [dataSource]=\"dataSource\" matSort  (matSortChange)=\"getSortedData($event)\" matSortActive=\"building_code\" matSortDirection=\"asc\" class=\"mat-elevation-z8\">\n\n\n            <ng-container matColumnDef=\"building_code\" >\n                <th mat-header-cell *matHeaderCellDef mat-sort-header> Kód </th>\n                <td mat-cell *matCellDef=\"let element\"> {{element.building_code}}\n                </td>\n            </ng-container>\n\n\n\n            <ng-container matColumnDef=\"name\">\n                <th mat-header-cell *matHeaderCellDef>Název</th>\n                <td mat-cell *matCellDef=\"let element\"> {{element.name}} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"keys\">\n                <th mat-header-cell *matHeaderCellDef>Klíče</th>\n                <td mat-cell *matCellDef=\"let element\"> {{element.keys}} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"address\">\n                <th mat-header-cell *matHeaderCellDef> Adresa </th>\n                <td mat-cell *matCellDef=\"let element\"> {{element.address}} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"area_name\">\n                <th mat-header-cell *matHeaderCellDef> Oblast </th>\n                <td mat-cell *matCellDef=\"let element\">\n                    <button mat-button routerLink=\"/areas/edit/{{element.area_id}}\"> {{element.area_name}} </button>\n                </td>\n            </ng-container>\n\n\n            <ng-container matColumnDef=\"action\">\n                <th mat-header-cell *matHeaderCellDef> Akce </th>\n                <td mat-cell *matCellDef=\"let element\">\n\n                    <button [matTooltip]=\"element.note\" mat-icon-button>\n                        <mat-icon>note</mat-icon>\n                    </button>\n\n                    <button (click)=\"openMap(element.gps_lat, element.gps_lon)\" matTooltip=\"Otevřit na google maps\" mat-icon-button>\n                        <mat-icon>gps_fixed</mat-icon>\n                    </button>\n                    <button  routerLink=\"{{element.id}}\" routerLinkActive matTooltip=\"Detail objektu\" mat-icon-button>\n                        <mat-icon>info</mat-icon>\n                    </button>\n\n                </td>\n            </ng-container>\n\n\n            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n</table>\n\n<div *ngIf=\"loading\" style=\"display: flex; justify-content: center; align-items: center\">\n    <mat-spinner></mat-spinner>\n</div>\n\n<mat-paginator [pageIndex]=0 [pageSize]=\"50\" showFirstLastButtons (page)=\"getNext($event)\"></mat-paginator>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.html":
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.html ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form>\n\n    <h3>Přidat fotku k objektu</h3>\n        <input type=\"file\" (change)=\"onFileChanged($event)\">\n    <br>\n    <div *ngIf=\"errorMessage\" style=\"padding:10px; color: red;\">\n        {{errorMessage}}\n    </div>\n    <br>\n    <button mat-raised-button (click)=\"dialogRef.close(false)\">Zrušit</button>\n    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;\n    <button mat-button type=\"submit\" (click)=\"onUpload()\">\n        Přidat\n    </button>\n\n</form>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/show-building/show-building.component.html":
/*!*******************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/show-building/show-building.component.html ***!
  \*******************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<mat-toolbar color=\"success\" role=\"header\" class=\"primary-toolbar\">\n    <div fxflex=\"50px\" style=\"flex: 1 1 50px; box-sizing: border-box; max-width: 50px; min-width: 50px;\" ng-reflect-flex=\"50px\">\n        <button routerLink=\"/buildings\" routerLinkActive type=\"button\" class=\"menu-btn\" mat-icon-button>\n            <mat-icon>business</mat-icon>\n        </button>\n\n    </div>\n\n\n    <div style=\"flex: 1 1 400px;box-sizing: border-box;max-width: 100px;min-width: 100px; margin-right:40px;\"> Detail objektu </div>\n\n\n    <button (click)=\"addImage()\" matTooltip=\"Nahrát fotku\" type=\"button\" class=\"menu-btn\" mat-icon-button>\n        <mat-icon>insert_photo</mat-icon>\n    </button>\n\n    <!-- This fills the remaining space of the current row -->\n    <span class=\"fill-space\"></span>\n</mat-toolbar>\n\n<mat-card class=\"building-card\" *ngIf=\"!loading\">\n\n    <mat-card-header>\n        <mat-card-title *ngIf=\"data.building.archived === 0\"> {{data.building.name}} </mat-card-title>\n        <mat-card-title *ngIf=\"data.building.archived === 1\"> Objekt {{data.building.name}} je archivován </mat-card-title>\n<!--        <mat-card-subtitle></mat-card-subtitle>-->\n    </mat-card-header>\n\n    <div class=\"container\" [style.opacity]=\"(data.building.archived === 1) ? '0.4' : '1.0'\">\n        <div class=\"image\" *ngFor=\"let photo of data.photos; let i = index\">\n            <a href=\"{{photo.url}}\" target=\"_blank\"><img src=\"{{photo.url}}\" alt=\"{{photo.name}}\"></a>\n        </div>\n    </div>\n\n    <mat-card-content [style.opacity]=\"(data.building.archived === 1) ? '0.4' : '1.0'\">\n        <div class=\"NW-container\">\n            <div class=\"container-item\">\n                <h2>Informace</h2>\n\n                <form [formGroup]=\"formGroup\">\n                    <table class=\"building-table\">\n\n                        <tr>\n                            <td>Oblast</td>\n                            <td>\n                                <mat-form-field>\n                                    <mat-select formControlName=\"areas\" multiple placeholder=\"Vyberte oblast\">\n                                        <mat-option *ngFor=\"let area of areas\" [value]=\"area.id\">\n                                            {{area.name}}\n                                        </mat-option>\n                                    </mat-select>\n                                </mat-form-field>\n                            </td>\n                        </tr>\n\n\n                        <tr>\n                            <td>Název</td>\n                            <td>\n                                <mat-form-field>\n                                    <input matInput placeholder=\"Zadejte název\" formControlName=\"name\" required>\n                                </mat-form-field>\n                            </td>\n                        </tr>\n\n\n                        <tr>\n                            <td>Kód</td>\n                            <td>\n                                <mat-form-field>\n                                    <input matInput placeholder=\"Zadejte kód objektu\" formControlName=\"building_code\" required>\n                                </mat-form-field>\n                           </td>\n                        </tr>\n\n                        <tr>\n                            <td>Adresa</td>\n                            <td>\n                                <mat-form-field>\n                                    <input matInput placeholder=\"Zadejte adresu\" formControlName=\"address\" required>\n                                </mat-form-field>\n                            </td>\n                        </tr>\n\n                        <tr>\n                            <td>GPS</td>\n                            <td>\n                                <mat-form-field>\n                                    <input matInput placeholder=\"GPS souřadnice\" formControlName=\"gps\" required>\n                                </mat-form-field>\n                            </td>\n                        </tr>\n\n                        <tr>\n                            <td>Klíče</td>\n                            <td>\n                                <mat-form-field>\n                                    <input matInput placeholder=\"Klíče\" formControlName=\"keys\">\n                                </mat-form-field>\n                            </td>\n                        </tr>\n\n\n                        <tr>\n                            <td>Poznámka</td>\n                            <td>\n                                <mat-form-field>\n                                    <textarea matInput placeholder=\"Poznámka\" formControlName=\"note\">\n                                    </textarea>\n                                </mat-form-field>\n                            </td>\n                        </tr>\n\n                        <tr>\n                            <td colspan=\"2\">\n                            <div *ngIf=\"saveLoading; else button\" style=\"display: flex; justify-content: center; align-items: center\">\n                                <mat-spinner></mat-spinner>\n                            </div>\n                            </td>\n\n                            <ng-template #button>\n                                <td colspan=\"2\" *ngIf=\"data.building.archived === 0\">\n                                    <h2>{{responseMessage}}</h2>\n                                    <button mat-button style=\"background-color: #a43236\" (click)=\"delete()\">Smazat</button>\n                                    <button mat-button (click)=\"openMap()\">Zobrazit na mapě</button>\n                                    <button mat-button (click)=\"sendForm()\" [disabled]=\"formGroup.invalid\">Uložit</button>\n                                </td>\n                            </ng-template>\n\n                        </tr>\n\n\n\n                    </table>\n                </form>\n            </div>\n\n        <div class=\"container-item\">\n            <h2>Správa obrázků</h2>\n            <table class=\"building-table\">\n\n                <tr *ngFor=\"let photo of data.photos; let i = index\">\n                    <td><a href=\"{{photo.url}}\" target=\"_blank\"><img width=\"100\" height=\"100\" src=\"{{photo.url}}\" alt=\"{{photo.name}}\"></a></td>\n                    <td>\n\n                        <button (click)=\"removeImage(photo.id, i)\" matTooltip=\"Smazat fotku\" type=\"button\" class=\"menu-btn\" mat-icon-button>\n                            <mat-icon>delete</mat-icon>\n                        </button>\n                    </td>\n                </tr>\n\n\n            </table>\n            </div>\n        </div>\n    </mat-card-content>\n</mat-card>\n\n<div *ngIf=\"loading\" style=\"display: flex; justify-content: center; align-items: center\">\n    <mat-spinner></mat-spinner>\n</div>\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/home/home.component.html":
/*!***************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/home/home.component.html ***!
  \***************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h1>Vítejte {{currentUser.firstname}}!</h1>\n<p>Vítejte jste v aplikace OSE Security</p>\n\n<mat-grid-list cols=\"4\" rowHeight=\"150px\">\n\n    <mat-grid-tile>\n        <mat-card class=\"dashboard-card\">\n            <mat-card-content>\n                <a mat-icon style=\"text-align: center;\"><mat-icon style=\"font-size:80px; margin-top:5px; margin-left:-10px;\">gps_fixed</mat-icon></a>\n                <h1> <span *ngIf=\"!loading\">{{stats.areas}}</span> <small> Oblastí</small></h1>\n            </mat-card-content>\n        </mat-card>\n    </mat-grid-tile>\n\n\n    <mat-grid-tile>\n        <mat-card class=\"dashboard-card\">\n            <mat-card-content>\n                <a mat-icon style=\"text-align: center;\"><mat-icon style=\"font-size:80px; padding: 5px;\">business</mat-icon></a>\n                <h1><span *ngIf=\"!loading\">{{stats.buildings}}</span> <small> Objektů</small></h1>\n            </mat-card-content>\n        </mat-card>\n    </mat-grid-tile>\n\n\n    <mat-grid-tile>\n        <mat-card class=\"dashboard-card\">\n            <mat-card-content style=\"text-align: center;\">\n                <a mat-icon style=\"text-align: center;\"><mat-icon style=\"font-size:80px; padding: 5px;\">photo_camera</mat-icon></a>\n                <h1><span *ngIf=\"!loading\">{{stats.images}}</span> <small> Fotek</small></h1>\n            </mat-card-content>\n        </mat-card>\n    </mat-grid-tile>\n\n\n\n    <mat-grid-tile>\n        <mat-card class=\"dashboard-card\">\n            <mat-card-content>\n                <a mat-icon style=\"text-align: center;\"><mat-icon style=\"font-size:80px;\">face</mat-icon></a>\n                <h1> <span *ngIf=\"!loading\">{{stats.users}}</span> <small> Uživatelů</small></h1>\n            </mat-card-content>\n        </mat-card>\n    </mat-grid-tile>\n\n    <mat-grid-tile colspan=\"4\">\n        <mat-card class=\"dashboard-full-card\">\n            <mat-card-content>\n                <table>\n                    <tr>\n                        <td><mat-icon>warning</mat-icon></td>\n                        <td><span *ngIf=\"!loading\">{{stats.unattached}}</span> Nepřiřazených objektů</td>\n                    </tr>\n                    <tr>\n                        <td><mat-icon>info</mat-icon></td>\n                        <td><span *ngIf=\"!loading\"></span> Verze mobilni aplikace 1.2</td>\n                    </tr>\n                    <tr>\n                        <td><mat-icon>info</mat-icon></td>\n                        <td><span *ngIf=\"!loading\"></span> Verze webové aplikace 1.1</td>\n\n                    </tr>\n                </table>\n            </mat-card-content>\n        </mat-card>\n    </mat-grid-tile>\n</mat-grid-list>\n\n\n\n<h3 style=\"margin-top: 40px;\">Seznam záloh</h3>\n<div class=\"dashboard-full-card gray\" *ngIf=\"!loading\">\n        <table width=\"100%\" cellpadding=\"10\" cellspacing=\"2\">\n           <tr style=\"font-weight: bold;\">\n                <td>Název</td>\n                <td>Datum vytvoření</td>\n                <td>Typ</td>\n                <td>Akce</td>\n           </tr>\n          <tr *ngIf=\"creatingBackup\">\n            <td colspan=\"2\" style=\"color: white; font-weight: bold;\">Vytvářím zálohu... </td>\n            <td style=\"height: 10px;\"><mat-spinner style=\"height: 10px;\"></mat-spinner></td>\n          </tr>\n           <tr *ngFor=\"let b of backupsParsed;\">\n                <td>{{b.filename}}</td>\n                <td>{{b.datetime}}</td>\n                <td>\n                    <span *ngIf=\"b.type === 'files'\">Soubory</span>\n                    <span *ngIf=\"b.type === 'database'\">Databáze</span>\n                </td>\n                <td>\n                    <button mat-button (click)=\"download(b.filename)\" >\n                    <mat-icon>cloud_download</mat-icon>\n                    Stažení zálohy\n                  </button>\n                  <button mat-button style=\"background-color: #a43236\" (click)=\"delete(b.filename)\" >\n                    <mat-icon>delete</mat-icon>\n                    Smazat\n                  </button>\n                </td>\n           </tr>\n        </table>\n</div>\n\n\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/login/login.component.html":
/*!*****************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/login/login.component.html ***!
  \*****************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<h2>Login</h2>-->\n<!--<form [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit()\">-->\n<!--    <div class=\"form-group\">-->\n<!--        <label for=\"username\">Username</label>-->\n<!--        <input type=\"text\" formControlName=\"username\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.username.errors }\" />-->\n<!--        <div *ngIf=\"submitted && f.username.errors\" class=\"invalid-feedback\">-->\n<!--            <div *ngIf=\"f.username.errors.required\">Username is required</div>-->\n<!--        </div>-->\n<!--    </div>-->\n<!--    <div class=\"form-group\">-->\n<!--        <label for=\"password\">Password</label>-->\n<!--        <input type=\"password\" formControlName=\"password\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.password.errors }\" />-->\n<!--        <div *ngIf=\"submitted && f.password.errors\" class=\"invalid-feedback\">-->\n<!--            <div *ngIf=\"f.password.errors.required\">Password is required</div>-->\n<!--        </div>-->\n<!--    </div>-->\n<!--    <div class=\"form-group\">-->\n<!--        <button [disabled]=\"loading\" class=\"btn btn-primary\">-->\n<!--            <span *ngIf=\"loading\" class=\"spinner-border spinner-border-sm mr-1\"></span>-->\n<!--            Login-->\n<!--        </button>-->\n<!--        <a routerLink=\"/register\" class=\"btn btn-link\">Register</a>-->\n<!--    </div>-->\n<!--</form>-->\n\n\n<div class=\"login-wrapper\" fxLayout=\"row\" fxLayoutAlign=\"center center\">\n\n    <mat-card class=\"box\">\n        <mat-card-header>\n            <img src=\"../assets/images/logo_ose_white.png\" width=\"219\" height=\"33\" />\n\n            <mat-card-title>Přihlášení</mat-card-title>\n        </mat-card-header>\n\n        <form class=\"example-form\" [formGroup]=\"loginForm\" (ngSubmit)=\"onSubmit()\">\n            <mat-card-content>\n\n                <mat-form-field class=\"example-full-width\">\n                    <input matInput placeholder=\"Uživatelské jméno\" formControlName=\"username\"  class=\"ng-invalid\" [ngClass]=\"{ 'is-invalid': submitted && f.username.errors }\" >\n                    <div *ngIf=\"submitted && f.username.errors\" class=\"invalid-feedback\">\n                        <div *ngIf=\"f.username.errors.required\">Username is required</div>\n                    </div>\n                </mat-form-field>\n\n                <mat-form-field class=\"example-full-width\">\n                <input matInput type=\"password\" placeholder=\"Heslo\" formControlName=\"password\" class=\"ng-invalid\"  [ngClass]=\"{ 'is-invalid': submitted && f.password.errors }\" />\n                <div *ngIf=\"submitted && f.password.errors\" class=\"invalid-feedback\">\n                    <div *ngIf=\"f.password.errors.required\">Password is required</div>\n                </div>\n                </mat-form-field>\n\n\n            </mat-card-content>\n\n            <button mat-stroked-button [disabled]=\"loading\" class=\"btn-block\">\n                <span *ngIf=\"loading\" class=\"spinner-border spinner-border-sm mr-1\"></span>\n                Přihlásit se\n            </button>\n        </form>\n    </mat-card>\n\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/register/register.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/routes/register/register.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2>Register</h2>\n<form [formGroup]=\"registerForm\" (ngSubmit)=\"onSubmit()\">\n    <div class=\"form-group\">\n        <label for=\"firstName\">First Name</label>\n        <input type=\"text\" formControlName=\"firstName\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.firstName.errors }\" />\n        <div *ngIf=\"submitted && f.firstName.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"f.firstName.errors.required\">First Name is required</div>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"lastName\">Last Name</label>\n        <input type=\"text\" formControlName=\"lastName\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.lastName.errors }\" />\n        <div *ngIf=\"submitted && f.lastName.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"f.lastName.errors.required\">Last Name is required</div>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"username\">Username</label>\n        <input type=\"text\" formControlName=\"username\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.username.errors }\" />\n        <div *ngIf=\"submitted && f.username.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"f.username.errors.required\">Username is required</div>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"password\">Password</label>\n        <input type=\"password\" formControlName=\"password\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && f.password.errors }\" />\n        <div *ngIf=\"submitted && f.password.errors\" class=\"invalid-feedback\">\n            <div *ngIf=\"f.password.errors.required\">Password is required</div>\n            <div *ngIf=\"f.password.errors.minlength\">Password must be at least 6 characters</div>\n        </div>\n    </div>\n    <div class=\"form-group\">\n        <button [disabled]=\"loading\" class=\"btn btn-primary\">\n            <span *ngIf=\"loading\" class=\"spinner-border spinner-border-sm mr-1\"></span>\n            Register\n        </button>\n        <a routerLink=\"/login\" class=\"btn btn-link\">Cancel</a>\n    </div>\n</form>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/alert/alert.component.html":
/*!****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/alert/alert.component.html ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"message\" [ngClass]=\"message.cssClass\">{{message.text}}</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/confirm-dialog/confirm-dialog.component.html":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/confirm-dialog/confirm-dialog.component.html ***!
  \**********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h2>{{title}}</h2>\n<p>{{message}}</p>\n\n<div style=\"width: 100%; display: flex; justify-content: space-between; align-items: center;\">\n<button mat-raised-button color=\"warn\" (click)=\"dialogRef.close(true)\">{{confirmText}}</button>\n<button mat-raised-button (click)=\"dialogRef.close(false)\">Zrušit</button>\n</div>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/notfound/notfound.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/notfound/notfound.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"not-found-wrapper\">\n    <h1>Stránka nebyla nalezena</h1>\n    <p>Omlouváme se za způsobené potíže</p>\n    <button mat-raised-button (click)=\"goBack()\">\n        <mat-icon>arrow_backward</mat-icon>\n       Zpět\n    </button>\n</div>\n");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/_helpers/auth.guard.ts":
/*!****************************************!*\
  !*** ./src/app/_helpers/auth.guard.ts ***!
  \****************************************/
/*! exports provided: AuthGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return AuthGuard; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");




let AuthGuard = class AuthGuard {
    constructor(router, authenticationService) {
        this.router = router;
        this.authenticationService = authenticationService;
    }
    canActivate(route, state) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // authorised so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
};
AuthGuard.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_3__["AuthenticationService"] }
];
AuthGuard = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], AuthGuard);



/***/ }),

/***/ "./src/app/_helpers/error.interceptor.ts":
/*!***********************************************!*\
  !*** ./src/app/_helpers/error.interceptor.ts ***!
  \***********************************************/
/*! exports provided: ErrorInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorInterceptor", function() { return ErrorInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");





let ErrorInterceptor = class ErrorInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        return next.handle(request).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(err => {
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                location.reload(true);
            }
            const error = err.error.message || err.statusText;
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["throwError"])(error);
        }));
    }
};
ErrorInterceptor.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_4__["AuthenticationService"] }
];
ErrorInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], ErrorInterceptor);



/***/ }),

/***/ "./src/app/_helpers/fake-backend.ts":
/*!******************************************!*\
  !*** ./src/app/_helpers/fake-backend.ts ***!
  \******************************************/
/*! exports provided: FakeBackendInterceptor, fakeBackendProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FakeBackendInterceptor", function() { return FakeBackendInterceptor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fakeBackendProvider", function() { return fakeBackendProvider; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





// array in local storage for registered users
let users = JSON.parse(localStorage.getItem('users')) || [];
let FakeBackendInterceptor = class FakeBackendInterceptor {
    intercept(request, next) {
        const { url, method, headers, body } = request;
        // wrap in delayed observable to simulate server api call
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(null)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["mergeMap"])(handleRoute))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["materialize"])()) // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["delay"])(500))
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["dematerialize"])());
        function handleRoute() {
            switch (true) {
                case url.endsWith('/users/authenticate') && method === 'POST':
                    return authenticate();
                case url.endsWith('/users/register') && method === 'POST':
                    return register();
                case url.endsWith('/users') && method === 'GET':
                    return getUsers();
                case url.match(/\/users\/\d+$/) && method === 'DELETE':
                    return deleteUser();
                default:
                    // pass through any requests not handled above
                    return next.handle(request);
            }
        }
        // route functions
        function authenticate() {
            const { username, password } = body;
            const user = users.find(x => x.username === username && x.password === password);
            if (!user)
                return error('Username or password is incorrect');
            return ok({
                id: user.id,
                username: user.username,
                firstName: user.firstName,
                lastName: user.lastName,
                token: 'fake-jwt-token'
            });
        }
        function register() {
            const user = body;
            if (users.find(x => x.username === user.username)) {
                return error('Username "' + user.username + '" is already taken');
            }
            user.id = users.length ? Math.max(...users.map(x => x.id)) + 1 : 1;
            users.push(user);
            localStorage.setItem('users', JSON.stringify(users));
            return ok();
        }
        function getUsers() {
            if (!isLoggedIn())
                return unauthorized();
            return ok(users);
        }
        function deleteUser() {
            if (!isLoggedIn())
                return unauthorized();
            users = users.filter(x => x.id !== idFromUrl());
            localStorage.setItem('users', JSON.stringify(users));
            return ok();
        }
        // helper functions
        function ok(body) {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["of"])(new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpResponse"]({ status: 200, body }));
        }
        function error(message) {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])({ error: { message } });
        }
        function unauthorized() {
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_3__["throwError"])({ status: 401, error: { message: 'Unauthorised' } });
        }
        function isLoggedIn() {
            return headers.get('Authorization') === 'Bearer fake-jwt-token';
        }
        function idFromUrl() {
            const urlParts = url.split('/');
            return parseInt(urlParts[urlParts.length - 1]);
        }
    }
};
FakeBackendInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], FakeBackendInterceptor);

const fakeBackendProvider = {
    // use fake backend in place of Http service for backend-less development
    provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HTTP_INTERCEPTORS"],
    useClass: FakeBackendInterceptor,
    multi: true
};


/***/ }),

/***/ "./src/app/_helpers/index.ts":
/*!***********************************!*\
  !*** ./src/app/_helpers/index.ts ***!
  \***********************************/
/*! exports provided: AuthGuard, ErrorInterceptor, JwtInterceptor, FakeBackendInterceptor, fakeBackendProvider */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _auth_guard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./auth.guard */ "./src/app/_helpers/auth.guard.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthGuard", function() { return _auth_guard__WEBPACK_IMPORTED_MODULE_1__["AuthGuard"]; });

/* harmony import */ var _error_interceptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./error.interceptor */ "./src/app/_helpers/error.interceptor.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ErrorInterceptor", function() { return _error_interceptor__WEBPACK_IMPORTED_MODULE_2__["ErrorInterceptor"]; });

/* harmony import */ var _jwt_interceptor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./jwt.interceptor */ "./src/app/_helpers/jwt.interceptor.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JwtInterceptor", function() { return _jwt_interceptor__WEBPACK_IMPORTED_MODULE_3__["JwtInterceptor"]; });

/* harmony import */ var _fake_backend__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./fake-backend */ "./src/app/_helpers/fake-backend.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FakeBackendInterceptor", function() { return _fake_backend__WEBPACK_IMPORTED_MODULE_4__["FakeBackendInterceptor"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "fakeBackendProvider", function() { return _fake_backend__WEBPACK_IMPORTED_MODULE_4__["fakeBackendProvider"]; });








/***/ }),

/***/ "./src/app/_helpers/jwt.interceptor.ts":
/*!*********************************************!*\
  !*** ./src/app/_helpers/jwt.interceptor.ts ***!
  \*********************************************/
/*! exports provided: JwtInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JwtInterceptor", function() { return JwtInterceptor; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../_services */ "./src/app/_services/index.ts");



let JwtInterceptor = class JwtInterceptor {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    intercept(request, next) {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        }
        return next.handle(request);
    }
};
JwtInterceptor.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"] }
];
JwtInterceptor = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], JwtInterceptor);



/***/ }),

/***/ "./src/app/_services/alert.service.ts":
/*!********************************************!*\
  !*** ./src/app/_services/alert.service.ts ***!
  \********************************************/
/*! exports provided: AlertService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return AlertService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");




let AlertService = class AlertService {
    constructor(router) {
        this.router = router;
        this.subject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["Subject"]();
        this.keepAfterRouteChange = false;
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        this.router.events.subscribe(event => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_2__["NavigationStart"]) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                }
                else {
                    // clear alert message
                    this.clear();
                }
            }
        });
    }
    getAlert() {
        return this.subject.asObservable();
    }
    success(message, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: 'success', text: message });
    }
    error(message, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: 'error', text: message });
    }
    clear() {
        // clear by calling subject.next() without parameters
        this.subject.next();
    }
};
AlertService.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AlertService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], AlertService);



/***/ }),

/***/ "./src/app/_services/api.service.ts":
/*!******************************************!*\
  !*** ./src/app/_services/api.service.ts ***!
  \******************************************/
/*! exports provided: ApiService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return ApiService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");





let ApiService = class ApiService {
    constructor(http) {
        this.http = http;
    }
    getBuildings(offset = 0, filterSort = {}) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (Object.keys(filterSort).length > 0) {
                return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/list/' + offset, filterSort, this.defaultHttpClientOptions)
                    .pipe().toPromise();
            }
            else {
                return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/list/' + offset, this.defaultHttpClientOptions)
                    .pipe().toPromise();
            }
        });
    }
    getBuilding(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/detail/' + id, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    addBuilding(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/add', data, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    saveBuilding(id, data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/detail/' + id, data, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    uploadImage(id, data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/upload', data, { headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'X-workbox-header': id }) })
                .pipe().toPromise();
        });
    }
    removeImage(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/remove-image/' + id, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getImage(url) {
        return this.http.get(url, { responseType: 'blob' }).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["map"])(e => e));
    }
    archiveBuilding(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/archive/' + id, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    deleteBuilding(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/delete/' + id, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getBuildingsStats() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/buildings/stats', this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getBuildingsMobile(areaId) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/buildings/' + areaId, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getAreas() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/areas', this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getArea(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/areas/edit/' + id, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    editArea(id, data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/areas/edit/' + id, data, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    addArea(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.post(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/areas/add', data, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    deleteArea(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/areas/delete/' + id, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    downloadApk(version) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const response = yield this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/download/' + version, { responseType: 'blob', observe: 'response', })
                .pipe().toPromise();
            return response.body;
        });
    }
    downloadDatabaseBackup() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const response = yield this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/backup/download/database/', { responseType: 'blob', observe: 'response', })
                .pipe().toPromise();
            return response;
        });
    }
    downloadFilesBackup() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/backup/create/files/', this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getBackupList() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/backup/list/', this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    deleteBackup(filename) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/backup/delete/' + filename, this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    getStats() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return this.http.get(_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl + '/admin/stats', this.defaultHttpClientOptions)
                .pipe().toPromise();
        });
    }
    get defaultHttpClientOptions() {
        return { headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpHeaders"]({ 'Content-Type': 'application/json' }) };
    }
};
ApiService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
ApiService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])()
], ApiService);



/***/ }),

/***/ "./src/app/_services/authentication.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/_services/authentication.service.ts ***!
  \*****************************************************/
/*! exports provided: AuthenticationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return AuthenticationService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");






let AuthenticationService = class AuthenticationService {
    constructor(http) {
        this.http = http;
        this.currentUserSubject = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    login(username, password) {
        return this.http.post(`${_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/admin/users/authenticate`, { username, password })
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_5__["map"])(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            this.currentUserSubject.next(user);
            return user;
        }));
    }
    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
};
AuthenticationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
AuthenticationService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], AuthenticationService);



/***/ }),

/***/ "./src/app/_services/index.ts":
/*!************************************!*\
  !*** ./src/app/_services/index.ts ***!
  \************************************/
/*! exports provided: AlertService, AuthenticationService, UserService, ApiService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _alert_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alert.service */ "./src/app/_services/alert.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AlertService", function() { return _alert_service__WEBPACK_IMPORTED_MODULE_1__["AlertService"]; });

/* harmony import */ var _authentication_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./authentication.service */ "./src/app/_services/authentication.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AuthenticationService", function() { return _authentication_service__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"]; });

/* harmony import */ var _user_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./user.service */ "./src/app/_services/user.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return _user_service__WEBPACK_IMPORTED_MODULE_3__["UserService"]; });

/* harmony import */ var _api_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api.service */ "./src/app/_services/api.service.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return _api_service__WEBPACK_IMPORTED_MODULE_4__["ApiService"]; });








/***/ }),

/***/ "./src/app/_services/user.service.ts":
/*!*******************************************!*\
  !*** ./src/app/_services/user.service.ts ***!
  \*******************************************/
/*! exports provided: UserService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UserService", function() { return UserService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../environments/environment */ "./src/environments/environment.ts");




let UserService = class UserService {
    constructor(http) {
        this.http = http;
    }
    getAll() {
        return this.http.get(`${_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl}/admin/users`);
    }
    register(user) {
        return this.http.post(`${_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl}/admin/users/register`, user);
    }
    delete(id) {
        return this.http.delete(`${_environments_environment__WEBPACK_IMPORTED_MODULE_3__["environment"].apiUrl}/admin/users/${id}`);
    }
};
UserService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
UserService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({ providedIn: 'root' })
], UserService);



/***/ }),

/***/ "./src/app/app.component.css":
/*!***********************************!*\
  !*** ./src/app/app.component.css ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".app-padding {\n    padding:20px;\n}\n\n.mat-input-element {\n    color:#000 !important;\n}\n\n.mat-button .mat-button-base {\n    box-shadow: 2px 2px 2px 2px #3cfdff !important;\n\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvYXBwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxZQUFZO0FBQ2hCOztBQUVBO0lBQ0kscUJBQXFCO0FBQ3pCOztBQUVBO0lBQ0ksOENBQThDOztBQUVsRCIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmFwcC1wYWRkaW5nIHtcbiAgICBwYWRkaW5nOjIwcHg7XG59XG5cbi5tYXQtaW5wdXQtZWxlbWVudCB7XG4gICAgY29sb3I6IzAwMCAhaW1wb3J0YW50O1xufVxuXG4ubWF0LWJ1dHRvbiAubWF0LWJ1dHRvbi1iYXNlIHtcbiAgICBib3gtc2hhZG93OiAycHggMnB4IDJweCAycHggIzNjZmRmZiAhaW1wb3J0YW50O1xuXG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/layout */ "./node_modules/@angular/cdk/esm2015/layout.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./_services */ "./src/app/_services/index.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");






let AppComponent = class AppComponent {
    constructor(changeDetectorRef, media, router, authenticationService, api, snackBar) {
        this.router = router;
        this.authenticationService = authenticationService;
        this.api = api;
        this.snackBar = snackBar;
        this.title = 'OSE Security';
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
    }
    OnDestroy() {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }
    isLoggedIn() {
        if (this.currentUser) {
            return true;
        }
        else {
            return false;
        }
    }
    downloadAPK(version) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const blob = yield this.api.downloadApk(version);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `ose-security-${version}.apk`; // Note the corrected template string
            document.body.appendChild(a); // (optional, but recommended for Firefox compatibility)
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        });
    }
    createBackup() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            let snackBarRef = this.snackBar.open('Záloha se vytváří...', undefined, {
                duration: 0,
            });
            try {
                const response = yield this.api.downloadDatabaseBackup();
                // const blob = response.body!;
                // const filename =  `osesecurity_${new Date().toISOString().replace(/[:.]/g, '-')}.sql`;
                //
                // const url = window.URL.createObjectURL(blob);
                // const a = document.createElement('a');
                // a.href = url;
                // a.download = filename;  // set the filename
                // document.body.appendChild(a);
                // a.click();
                // document.body.removeChild(a);
                // window.URL.revokeObjectURL(url);
                // snackBarRef.dismiss();
                // tslint:disable-next-line:max-line-length
                snackBarRef = this.snackBar.open('✅ Záloha databáze vytvořena, ⏳ Vytváří se záloha souborů, stav můžete sledovat na hlavní stránce...', undefined, { duration: 0 });
            }
            catch (error) {
                snackBarRef.dismiss();
                // tslint:disable-next-line:max-line-length
                snackBarRef = this.snackBar.open('❌ Záloha databáze se nepovedla, ⏳ Vytváří se záloha souborů, stav můžete sledovat na hlavní stránce...', undefined, { duration: 0 });
                console.error('Backup download failed', error);
            }
            try {
                this.api.downloadFilesBackup().then((response) => {
                    console.log(response);
                });
                // snackBarRef = this.snackBar.open('✅ Záloha souborů vytvořena.', undefined, { duration: 5000 });
            }
            catch (error) {
                snackBarRef.dismiss();
                console.error('Backup files download failed', error);
            }
        });
    }
    // Helper method to parse filename from header
    getFilenameFromHeader(header) {
        if (!header)
            return null;
        const matches = /filename="?([^"]+)"?/.exec(header);
        return matches && matches[1] ? matches[1] : null;
    }
    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_core__WEBPACK_IMPORTED_MODULE_2__["ChangeDetectorRef"] },
    { type: _angular_cdk_layout__WEBPACK_IMPORTED_MODULE_1__["MediaMatcher"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_4__["AuthenticationService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_4__["ApiService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.css */ "./src/app/app.component.css")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var _angular_material_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/icon */ "./node_modules/@angular/material/esm2015/icon.js");
/* harmony import */ var _angular_material_list__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/list */ "./node_modules/@angular/material/esm2015/list.js");
/* harmony import */ var _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/sidenav */ "./node_modules/@angular/material/esm2015/sidenav.js");
/* harmony import */ var _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/toolbar */ "./node_modules/@angular/material/esm2015/toolbar.js");
/* harmony import */ var _routing_module__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./routing.module */ "./src/app/routing.module.ts");
/* harmony import */ var _shared_shared_module__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./shared/shared.module */ "./src/app/shared/shared.module.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _routes_home__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./routes/home */ "./src/app/routes/home/index.ts");
/* harmony import */ var _routes_login__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./routes/login */ "./src/app/routes/login/index.ts");
/* harmony import */ var _routes_register__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./routes/register */ "./src/app/routes/register/index.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_flex_layout__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @angular/flex-layout */ "./node_modules/@angular/flex-layout/esm2015/flex-layout.js");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./_helpers */ "./src/app/_helpers/index.ts");
/* harmony import */ var _routes_buildings_buildings_module__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./routes/buildings/buildings.module */ "./src/app/routes/buildings/buildings.module.ts");
/* harmony import */ var _routes_areas_areas_module__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./routes/areas/areas.module */ "./src/app/routes/areas/areas.module.ts");
/* harmony import */ var _agm_core__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @agm/core */ "./node_modules/@agm/core/fesm2015/agm-core.js");
/* harmony import */ var _shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./shared/components/confirm-dialog/confirm-dialog.component */ "./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @angular/material/progress-spinner */ "./node_modules/@angular/material/esm2015/progress-spinner.js");


























let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"],
            _routes_home__WEBPACK_IMPORTED_MODULE_13__["HomeComponent"],
            _routes_login__WEBPACK_IMPORTED_MODULE_14__["LoginComponent"],
            _routes_register__WEBPACK_IMPORTED_MODULE_15__["RegisterComponent"],
            _shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_22__["ConfirmDialog"]
        ],
        imports: [
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_5__["BrowserAnimationsModule"],
            _angular_material_toolbar__WEBPACK_IMPORTED_MODULE_9__["MatToolbarModule"],
            _angular_material_icon__WEBPACK_IMPORTED_MODULE_6__["MatIconModule"],
            _angular_material_sidenav__WEBPACK_IMPORTED_MODULE_8__["MatSidenavModule"],
            _angular_material_list__WEBPACK_IMPORTED_MODULE_7__["MatListModule"],
            _routing_module__WEBPACK_IMPORTED_MODULE_10__["RoutingModule"],
            _shared_shared_module__WEBPACK_IMPORTED_MODULE_11__["SharedModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_12__["MatButtonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_16__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_16__["ReactiveFormsModule"],
            _angular_flex_layout__WEBPACK_IMPORTED_MODULE_17__["FlexLayoutModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_12__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_12__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_12__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_12__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_12__["MatGridListModule"],
            _routes_buildings_buildings_module__WEBPACK_IMPORTED_MODULE_19__["BuildingsModule"],
            _angular_material_sort__WEBPACK_IMPORTED_MODULE_23__["MatSortModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_24__["MatSnackBarModule"],
            _routes_areas_areas_module__WEBPACK_IMPORTED_MODULE_20__["AreasModule"],
            _agm_core__WEBPACK_IMPORTED_MODULE_21__["AgmCoreModule"].forRoot({
                apiKey: 'AIzaSyBiXLuymMKgk8kRW2clzP_SdqA9ywCPlwI',
                libraries: ['drawing']
            }),
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_25__["MatProgressSpinnerModule"]
        ],
        providers: [
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HTTP_INTERCEPTORS"], useClass: _helpers__WEBPACK_IMPORTED_MODULE_18__["JwtInterceptor"], multi: true },
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HTTP_INTERCEPTORS"], useClass: _helpers__WEBPACK_IMPORTED_MODULE_18__["ErrorInterceptor"], multi: true },
        ],
        entryComponents: [
            _shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_22__["ConfirmDialog"]
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_4__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/routes/areas/add-area/add-area.component.css":
/*!**************************************************************!*\
  !*** ./src/app/routes/areas/add-area/add-area.component.css ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("agm-map {\n    height: 500px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2FyZWFzL2FkZC1hcmVhL2FkZC1hcmVhLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxhQUFhO0FBQ2pCIiwiZmlsZSI6InNyYy9hcHAvcm91dGVzL2FyZWFzL2FkZC1hcmVhL2FkZC1hcmVhLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJhZ20tbWFwIHtcbiAgICBoZWlnaHQ6IDUwMHB4O1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/routes/areas/add-area/add-area.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/routes/areas/add-area/add-area.component.ts ***!
  \*************************************************************/
/*! exports provided: AddAreaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddAreaComponent", function() { return AddAreaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");





let AddAreaComponent = class AddAreaComponent {
    // tslint:disable-next-line:variable-name
    constructor(_formBuilder, API, router) {
        this._formBuilder = _formBuilder;
        this.API = API;
        this.router = router;
        this.lat = 49.178807;
        this.lng = 16.695596;
        this.colors = ['#fffd10', '#cc6376', '#60cccc', '#54cca0', '#8c75cc', '#fff5ab', '#ffb87c', '#14b7ff', '#3fff72'];
    }
    ngOnInit() {
        this.firstFormGroup = this._formBuilder.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            pin: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].minLength(4), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].maxLength(4)]],
        });
    }
    onMapReady(map) {
        this.initDrawingManager(map);
    }
    initDrawingManager(map) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const options = {
                drawingControl: true,
                drawingControlOptions: {
                    drawingModes: ['polygon']
                },
                polygonOptions: {
                    draggable: true,
                    editable: true
                },
                drawingMode: google.maps.drawing.OverlayType.POLYGON
            };
            this.drawingManager = new google.maps.drawing.DrawingManager(options);
            //
            // google.maps.event.addListener(this.drawingManager, 'overlaycomplete', function(event) {
            //
            // });
            google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (event) => {
                this.areaCoords = JSON.stringify(event.getPath().getArray());
                google.maps.event.addListener(event.getPath(), 'set_at', () => {
                    this.areaCoords = JSON.stringify(event.getPath().getArray());
                });
                google.maps.event.addListener(event.getPath(), 'insert_at', () => {
                    this.areaCoords = JSON.stringify(event.getPath().getArray());
                });
            });
            this.areas = yield this.API.getAreas();
            this.areas.forEach((area) => {
                const polygonCoords = JSON.parse(area.coords);
                // construct the polygon
                const polygon = new google.maps.Polygon({
                    paths: polygonCoords,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35
                });
                polygon.setMap(map);
            });
            this.drawingManager.setMap(map);
        });
    }
    savePolygon() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const formData = Object.assign({}, this.firstFormGroup.value, { coords: this.areaCoords });
            console.log(formData);
            const data = yield this.API.addArea(formData);
            console.log(data);
            this.loading = false;
            this.buildingsCount = data.buildings;
            setTimeout(() => {
                this.router.navigate(['/areas']);
            }, 5000);
        });
    }
};
AddAreaComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] }
];
AddAreaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-add-area',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-area.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/add-area/add-area.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-area.component.css */ "./src/app/routes/areas/add-area/add-area.component.css")).default]
    })
], AddAreaComponent);



/***/ }),

/***/ "./src/app/routes/areas/areas.component.css":
/*!**************************************************!*\
  !*** ./src/app/routes/areas/areas.component.css ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\n    width: 95%;\n    margin: 15px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2FyZWFzL2FyZWFzLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxVQUFVO0lBQ1YsWUFBWTtBQUNoQiIsImZpbGUiOiJzcmMvYXBwL3JvdXRlcy9hcmVhcy9hcmVhcy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsidGFibGUge1xuICAgIHdpZHRoOiA5NSU7XG4gICAgbWFyZ2luOiAxNXB4O1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/routes/areas/areas.component.ts":
/*!*************************************************!*\
  !*** ./src/app/routes/areas/areas.component.ts ***!
  \*************************************************/
/*! exports provided: AreasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AreasComponent", function() { return AreasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../shared/components/confirm-dialog/confirm-dialog.component */ "./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts");





let AreasComponent = class AreasComponent {
    constructor(api, dialog) {
        this.api = api;
        this.dialog = dialog;
        this.loading = true;
        this.displayedColumns = ['pin', 'name', 'action'];
        this.dataSource = new _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatTableDataSource"]();
    }
    ngOnInit() {
        this.init().then(() => {
            this.dataSource.paginator = this.paginator;
        });
    }
    init() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            this.dataSource.data = [];
            this.buildings = yield this.api.getAreas();
            this.dataSource.data = this.buildings;
            this.loading = false;
        });
    }
    deleteArea(id) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            return yield this.api.deleteArea(id);
        });
    }
    doFilter(value) {
        this.dataSource.filter = value.trim().toLocaleLowerCase();
    }
    openMap(long, lat) {
        window.open('http://', '_blank');
    }
    confirmDelete(id, areaName) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            let dialogRef;
            dialogRef = this.dialog.open(_shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_4__["ConfirmDialog"]);
            dialogRef.componentInstance.title = 'Upozornění';
            dialogRef.componentInstance.message = 'Opravdu chcete smazat ' + areaName + ' oblast?';
            dialogRef.componentInstance.confirmText = 'Ano';
            dialogRef.afterClosed().subscribe(result => {
                if (result === true) {
                    this.loading = true;
                    this.deleteArea(id).then(() => {
                        this.init();
                    });
                }
            });
        });
    }
};
AreasComponent.ctorParameters = () => [
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatPaginator"], { static: false })
], AreasComponent.prototype, "paginator", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: false })
], AreasComponent.prototype, "sort", void 0);
AreasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-areas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./areas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/areas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./areas.component.css */ "./src/app/routes/areas/areas.component.css")).default]
    })
], AreasComponent);



/***/ }),

/***/ "./src/app/routes/areas/areas.module.ts":
/*!**********************************************!*\
  !*** ./src/app/routes/areas/areas.module.ts ***!
  \**********************************************/
/*! exports provided: AreasModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AreasModule", function() { return AreasModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _add_area_add_area_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./add-area/add-area.component */ "./src/app/routes/areas/add-area/add-area.component.ts");
/* harmony import */ var _agm_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @agm/core */ "./node_modules/@agm/core/fesm2015/agm-core.js");
/* harmony import */ var _areas_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./areas.component */ "./src/app/routes/areas/areas.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _show_areas_show_areas_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./show-areas/show-areas.component */ "./src/app/routes/areas/show-areas/show-areas.component.ts");
/* harmony import */ var _edit_area_edit_area_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./edit-area/edit-area.component */ "./src/app/routes/areas/edit-area/edit-area.component.ts");












const routes = [
    {
        path: '',
        component: _areas_component__WEBPACK_IMPORTED_MODULE_5__["AreasComponent"],
    },
    {
        path: 'add',
        component: _add_area_add_area_component__WEBPACK_IMPORTED_MODULE_3__["AddAreaComponent"],
    },
    {
        path: 'show',
        component: _show_areas_show_areas_component__WEBPACK_IMPORTED_MODULE_10__["ShowAreasComponent"],
    },
    {
        path: 'edit/:id',
        component: _edit_area_edit_area_component__WEBPACK_IMPORTED_MODULE_11__["EditAreaComponent"],
    }
];
let AreasModule = class AreasModule {
};
AreasModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_add_area_add_area_component__WEBPACK_IMPORTED_MODULE_3__["AddAreaComponent"], _areas_component__WEBPACK_IMPORTED_MODULE_5__["AreasComponent"], _show_areas_show_areas_component__WEBPACK_IMPORTED_MODULE_10__["ShowAreasComponent"], _edit_area_edit_area_component__WEBPACK_IMPORTED_MODULE_11__["EditAreaComponent"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _agm_core__WEBPACK_IMPORTED_MODULE_4__["AgmCoreModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatExpansionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatGridListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTooltipModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatProgressSpinnerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatStepperModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_9__["ReactiveFormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_8__["RouterModule"].forChild(routes)
        ],
        exports: [
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatInputModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_8__["RouterModule"]
        ],
        providers: [
            _services_api_service__WEBPACK_IMPORTED_MODULE_7__["ApiService"]
        ]
    })
], AreasModule);



/***/ }),

/***/ "./src/app/routes/areas/edit-area/edit-area.component.css":
/*!****************************************************************!*\
  !*** ./src/app/routes/areas/edit-area/edit-area.component.css ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("agm-map {\n    height: 500px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2FyZWFzL2VkaXQtYXJlYS9lZGl0LWFyZWEuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGFBQWE7QUFDakIiLCJmaWxlIjoic3JjL2FwcC9yb3V0ZXMvYXJlYXMvZWRpdC1hcmVhL2VkaXQtYXJlYS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiYWdtLW1hcCB7XG4gICAgaGVpZ2h0OiA1MDBweDtcbn1cbiJdfQ== */");

/***/ }),

/***/ "./src/app/routes/areas/edit-area/edit-area.component.ts":
/*!***************************************************************!*\
  !*** ./src/app/routes/areas/edit-area/edit-area.component.ts ***!
  \***************************************************************/
/*! exports provided: EditAreaComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditAreaComponent", function() { return EditAreaComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");





let EditAreaComponent = class EditAreaComponent {
    // tslint:disable-next-line:variable-name
    constructor(API, route, formBuilder, router) {
        this.API = API;
        this.route = route;
        this.formBuilder = formBuilder;
        this.router = router;
        this.lat = 49.178807;
        this.lng = 16.695596;
    }
    ngOnInit() {
        this.area_id = this.route.snapshot.params.id;
        this.formGroup = this.formBuilder.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            pin: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].minLength(4), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].maxLength(4)]],
        });
    }
    onMapReady(map) {
        this.initDrawingManager(map);
    }
    initDrawingManager(map) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const options = {
                drawingControl: false,
                polygonOptions: {
                    draggable: false,
                    editable: true
                }
            };
            const image = '/assets/images/business.png';
            this.drawingManager = new google.maps.drawing.DrawingManager(options);
            this.area = yield this.API.getArea(this.area_id);
            this.formGroup.patchValue(this.area.area);
            const polygonCoords = JSON.parse(this.area.area.coords);
            this.areaCoords = this.area.area.coords;
            this.lat = polygonCoords[0].lat;
            this.lng = polygonCoords[0].lng;
            const polygon = new google.maps.Polygon({
                paths: polygonCoords,
                strokeColor: '#000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#14b7ff',
                fillOpacity: 0.35,
                editable: true
            });
            google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
                this.areaCoords = JSON.stringify(polygon.getPath().getArray());
                console.log(this.areaCoords);
            });
            google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
                this.areaCoords = JSON.stringify(polygon.getPath().getArray());
                console.log(this.areaCoords);
            });
            polygon.setMap(map);
            this.area.buildings.forEach((buldings) => {
                const marker = new google.maps.Marker({
                    position: { lat: buldings.gps_lat, lng: buldings.gps_lon },
                    title: buldings.name,
                    icon: image
                });
                marker.setMap(map);
            });
            this.drawingManager.setMap(map);
        });
    }
    saveArea() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            const formData = Object.assign({}, this.formGroup.value, { coords: this.areaCoords });
            console.log(formData);
            yield this.API.editArea(this.area_id, formData);
            this.loading = false;
            // this.buildingsCount = data.buildings;
            setTimeout(() => {
                this.router.navigate(['/areas']);
            }, 2000);
        });
    }
};
EditAreaComponent.ctorParameters = () => [
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["ActivatedRoute"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_4__["Router"] }
];
EditAreaComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-edit-area',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./edit-area.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/edit-area/edit-area.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./edit-area.component.css */ "./src/app/routes/areas/edit-area/edit-area.component.css")).default]
    })
], EditAreaComponent);



/***/ }),

/***/ "./src/app/routes/areas/show-areas/show-areas.component.css":
/*!******************************************************************!*\
  !*** ./src/app/routes/areas/show-areas/show-areas.component.css ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("agm-map {\n    height: 500px;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2FyZWFzL3Nob3ctYXJlYXMvc2hvdy1hcmVhcy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksYUFBYTtBQUNqQiIsImZpbGUiOiJzcmMvYXBwL3JvdXRlcy9hcmVhcy9zaG93LWFyZWFzL3Nob3ctYXJlYXMuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbImFnbS1tYXAge1xuICAgIGhlaWdodDogNTAwcHg7XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/routes/areas/show-areas/show-areas.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/routes/areas/show-areas/show-areas.component.ts ***!
  \*****************************************************************/
/*! exports provided: ShowAreasComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShowAreasComponent", function() { return ShowAreasComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../_services/api.service */ "./src/app/_services/api.service.ts");



let ShowAreasComponent = class ShowAreasComponent {
    // tslint:disable-next-line:variable-name
    constructor(API) {
        this.API = API;
        this.lat = 49.178807;
        this.lng = 16.695596;
        this.colors = ['#14b7ff', '#cc6376', '#60cccc', '#54cca0', '#8c75cc', '#fff5ab', '#ffb87c'];
    }
    ngOnInit() {
    }
    onMapReady(map) {
        this.initDrawingManager(map);
    }
    initDrawingManager(map) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const options = {
                drawingControl: false,
                polygonOptions: {
                    draggable: false,
                    editable: false
                }
            };
            this.drawingManager = new google.maps.drawing.DrawingManager(options);
            //
            // google.maps.event.addListener(this.drawingManager, 'overlaycomplete', function(event) {
            //
            // });
            // google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (event) => {
            //   this.areaCoords = JSON.stringify(event.getPath().getArray());
            //
            //   google.maps.event.addListener(event.getPath(), 'set_at',  () => {
            //     this.areaCoords = JSON.stringify(event.getPath().getArray());
            //   });
            //
            //   google.maps.event.addListener(event.getPath(), 'insert_at', ()  => {
            //     this.areaCoords = JSON.stringify(event.getPath().getArray());
            //   });
            //
            // });
            // google.maps.event.addListenerOnce(map, 'idle', (map: any) => {
            //     this.drawPolygons();
            // });
            this.areas = yield this.API.getAreas();
            let i = 0;
            this.areas.forEach((area) => {
                const polygonCoords = JSON.parse(area.coords);
                // construct the polygon
                const polygon = new google.maps.Polygon({
                    paths: polygonCoords,
                    strokeColor: '#000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: this.colors[i],
                    fillOpacity: 0.35
                });
                const bounds = new google.maps.LatLngBounds();
                polygonCoords.forEach((tmp) => {
                    bounds.extend(tmp);
                });
                const polygonCenter = bounds.getCenter();
                const markerIcon = {
                    url: 'http://1x1px.me/FFFFFF-0.png',
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(7, 7),
                };
                const marker = new google.maps.Marker({
                    position: polygonCenter,
                    title: area.name,
                    icon: markerIcon,
                    animation: google.maps.Animation.DROP,
                    label: {
                        text: area.name,
                        color: this.colors[i],
                        fontSize: '16px',
                        fontWeight: 'bold'
                    }
                });
                i++;
                marker.setMap(map);
                polygon.setMap(map);
            });
            this.drawingManager.setMap(map);
        });
    }
    drawPolygons(map) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
        });
    }
};
ShowAreasComponent.ctorParameters = () => [
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] }
];
ShowAreasComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-show-areas',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./show-areas.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/areas/show-areas/show-areas.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./show-areas.component.css */ "./src/app/routes/areas/show-areas/show-areas.component.css")).default]
    })
], ShowAreasComponent);



/***/ }),

/***/ "./src/app/routes/buildings/add-building/add-building.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/routes/buildings/add-building/add-building.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3JvdXRlcy9idWlsZGluZ3MvYWRkLWJ1aWxkaW5nL2FkZC1idWlsZGluZy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/routes/buildings/add-building/add-building.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/routes/buildings/add-building/add-building.component.ts ***!
  \*************************************************************************/
/*! exports provided: AddBuildingDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddBuildingDialog", function() { return AddBuildingDialog; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../_services/api.service */ "./src/app/_services/api.service.ts");





let AddBuildingDialog = 
// tslint:disable-next-line:component-class-suffix
class AddBuildingDialog {
    constructor(dialogRef, formBuilder, API) {
        this.dialogRef = dialogRef;
        this.formBuilder = formBuilder;
        this.API = API;
        this.formGroup = this.formBuilder.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            building_code: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].minLength(4), _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].maxLength(4)]],
        });
    }
    onSubmit(data) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (this.formGroup.valid) {
                let response;
                response = yield this.API.addBuilding(data);
                if (response.status === 'ok') {
                    this.dialogRef.close({ id: response.id });
                }
                else {
                    this.errorMessage = response.message;
                }
            }
        });
    }
};
AddBuildingDialog.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_4__["ApiService"] }
];
AddBuildingDialog = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-add-building',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-building.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/add-building/add-building.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-building.component.css */ "./src/app/routes/buildings/add-building/add-building.component.css")).default]
    })
    // tslint:disable-next-line:component-class-suffix
], AddBuildingDialog);



/***/ }),

/***/ "./src/app/routes/buildings/buildings.component.css":
/*!**********************************************************!*\
  !*** ./src/app/routes/buildings/buildings.component.css ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("table {\n    width: 95%;\n    margin: 15px;\n}\n\n.fill-space {\nflex: 1 1 auto;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2J1aWxkaW5ncy9idWlsZGluZ3MuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFVBQVU7SUFDVixZQUFZO0FBQ2hCOztBQUVBO0FBQ0EsY0FBYztBQUNkIiwiZmlsZSI6InNyYy9hcHAvcm91dGVzL2J1aWxkaW5ncy9idWlsZGluZ3MuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbInRhYmxlIHtcbiAgICB3aWR0aDogOTUlO1xuICAgIG1hcmdpbjogMTVweDtcbn1cblxuLmZpbGwtc3BhY2Uge1xuZmxleDogMSAxIGF1dG87XG59XG4iXX0= */");

/***/ }),

/***/ "./src/app/routes/buildings/buildings.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/routes/buildings/buildings.component.ts ***!
  \*********************************************************/
/*! exports provided: BuildingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildingsComponent", function() { return BuildingsComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _add_building_add_building_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./add-building/add-building.component */ "./src/app/routes/buildings/add-building/add-building.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");









let BuildingsComponent = class BuildingsComponent {
    // dataSource = new MatTableDataSource([]);
    constructor(api, dialog, router) {
        this.api = api;
        this.dialog = dialog;
        this.router = router;
        this.sorting = {};
        this.loading = true;
        this.progressBar = true;
        this.displayedColumns = ['building_code', 'name', 'address', 'keys', 'action'];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_5__["MatTableDataSource"]();
    }
    ngOnInit() {
        this.init().then(() => {
            this.BuildingsCount = this.buildings.rowCount;
            this.paginator.length = this.BuildingsCount;
            this.dataSource.sort = this.sort;
        });
    }
    init() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.buildings = yield this.api.getBuildings();
            this.areas = yield this.api.getAreas();
            this.dataSource.data = this.buildings.data;
            this.loading = false;
            this.progressBar = false;
        });
    }
    fullTextSearch(value) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.search = value;
            if (value.length === 0) {
                this.search = '';
            }
            else if (value.length <= 3) {
                return;
            }
            this.doFilter();
        });
    }
    getNext(event) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.doFilter(event.pageIndex);
        });
    }
    openMap(lat, lng) {
        window.open('https://www.google.com/maps/search/?api=1&query=' + lat + ',' + lng, '_blank');
    }
    areaFilter(event) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.areaFilterId = event.value;
            this.doFilter();
        });
    }
    getSortedData(e) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.sorting = e;
            this.doFilter();
        });
    }
    doFilter(offset = 0) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.progressBar = true;
            this.buildings = yield this.api.getBuildings(offset, Object.assign({}, this.sorting, { search: this.search }, { area: this.areaFilterId }));
            this.dataSource.data = this.buildings.data;
            this.BuildingsCount = this.buildings.rowCount;
            this.paginator.length = this.BuildingsCount;
            if (offset === 0) {
                this.paginator.pageIndex = 0;
            }
            this.progressBar = false;
        });
    }
    addBuilding() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            let dialogRef;
            dialogRef = this.dialog.open(_add_building_add_building_component__WEBPACK_IMPORTED_MODULE_7__["AddBuildingDialog"], {
                width: '16%'
            });
            dialogRef.afterClosed().subscribe(response => {
                if (response !== false) {
                    this.router.navigate(['/buildings/' + response.id]);
                }
            });
        });
    }
};
BuildingsComponent.ctorParameters = () => [
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_6__["ApiService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialog"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_8__["Router"] }
];
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: false })
], BuildingsComponent.prototype, "paginator", void 0);
tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_4__["MatSort"], { static: false })
], BuildingsComponent.prototype, "sort", void 0);
BuildingsComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-buildings',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./buildings.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/buildings.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./buildings.component.css */ "./src/app/routes/buildings/buildings.component.css")).default]
    })
], BuildingsComponent);



/***/ }),

/***/ "./src/app/routes/buildings/buildings.module.ts":
/*!******************************************************!*\
  !*** ./src/app/routes/buildings/buildings.module.ts ***!
  \******************************************************/
/*! exports provided: BuildingsModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BuildingsModule", function() { return BuildingsModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _buildings_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./buildings.component */ "./src/app/routes/buildings/buildings.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _show_building_show_building_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./show-building/show-building.component */ "./src/app/routes/buildings/show-building/show-building.component.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _add_building_add_building_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./add-building/add-building.component */ "./src/app/routes/buildings/add-building/add-building.component.ts");
/* harmony import */ var _show_building_add_building_image_add_building_image_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./show-building/add-building-image/add-building-image.component */ "./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.ts");











const routes = [
    {
        path: '',
        component: _buildings_component__WEBPACK_IMPORTED_MODULE_3__["BuildingsComponent"],
    },
    {
        path: ':id',
        component: _show_building_show_building_component__WEBPACK_IMPORTED_MODULE_7__["ShowBuildingComponent"],
    }
];
let BuildingsModule = class BuildingsModule {
};
BuildingsModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [_buildings_component__WEBPACK_IMPORTED_MODULE_3__["BuildingsComponent"], _show_building_show_building_component__WEBPACK_IMPORTED_MODULE_7__["ShowBuildingComponent"], _add_building_add_building_component__WEBPACK_IMPORTED_MODULE_9__["AddBuildingDialog"], _show_building_add_building_image_add_building_image_component__WEBPACK_IMPORTED_MODULE_10__["AddBuildingImageDialog"]],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatExpansionModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatGridListModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatTabsModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatToolbarModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatCardModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatButtonModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatTooltipModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatDialogModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatTableModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatPaginatorModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatProgressSpinnerModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatSortModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatProgressBarModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_8__["ReactiveFormsModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_6__["RouterModule"].forChild(routes),
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatSelectModule"]
        ],
        exports: [
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatFormFieldModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_4__["MatInputModule"],
        ],
        entryComponents: [_add_building_add_building_component__WEBPACK_IMPORTED_MODULE_9__["AddBuildingDialog"], _show_building_add_building_image_add_building_image_component__WEBPACK_IMPORTED_MODULE_10__["AddBuildingImageDialog"]],
        providers: [
            _services_api_service__WEBPACK_IMPORTED_MODULE_5__["ApiService"]
        ]
    })
], BuildingsModule);



/***/ }),

/***/ "./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.css":
/*!****************************************************************************************************!*\
  !*** ./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.css ***!
  \****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3JvdXRlcy9idWlsZGluZ3Mvc2hvdy1idWlsZGluZy9hZGQtYnVpbGRpbmctaW1hZ2UvYWRkLWJ1aWxkaW5nLWltYWdlLmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.ts":
/*!***************************************************************************************************!*\
  !*** ./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.ts ***!
  \***************************************************************************************************/
/*! exports provided: AddBuildingImageDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddBuildingImageDialog", function() { return AddBuildingImageDialog; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../_services/api.service */ "./src/app/_services/api.service.ts");




let AddBuildingImageDialog = 
// tslint:disable-next-line:component-class-suffix
class AddBuildingImageDialog {
    constructor(data, dialogRef, API) {
        this.data = data;
        this.dialogRef = dialogRef;
        this.API = API;
        this.buldingId = data.buildingId;
    }
    onFileChanged(event) {
        this.selectedFile = event.target.files[0];
    }
    onUpload() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.errorMessage = '';
            console.log(this.selectedFile);
            if (this.selectedFile) {
                if (this.selectedFile.type === 'image/png' || this.selectedFile.type === 'image/jpg' || this.selectedFile.type === 'image/jpeg') {
                    let response;
                    const uploadData = new FormData();
                    uploadData.append('file', this.selectedFile, this.selectedFile.name);
                    response = yield this.API.uploadImage(this.buldingId, uploadData);
                    if (response.status) {
                        this.dialogRef.close(true);
                    }
                    else {
                        this.errorMessage = 'Něco se pokazilo.';
                    }
                }
                else {
                    this.errorMessage = 'Zvolte pouze obrázek.';
                }
            }
        });
    }
};
AddBuildingImageDialog.ctorParameters = () => [
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"], args: [_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"],] }] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] },
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] }
];
AddBuildingImageDialog = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-add-building-image',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./add-building-image.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./add-building-image.component.css */ "./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.css")).default]
    })
    // tslint:disable-next-line:component-class-suffix
    ,
    tslib__WEBPACK_IMPORTED_MODULE_0__["__param"](0, Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Inject"])(_angular_material__WEBPACK_IMPORTED_MODULE_2__["MAT_DIALOG_DATA"]))
], AddBuildingImageDialog);



/***/ }),

/***/ "./src/app/routes/buildings/show-building/show-building.component.css":
/*!****************************************************************************!*\
  !*** ./src/app/routes/buildings/show-building/show-building.component.css ***!
  \****************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".building-card {\n    max-width: 100%;\n}\n\n/*.building-card-image {*/\n\n/*    background-image: url('https://material.angular.io/assets/img/examples/shiba1.jpg');*/\n\n/*    background-size: contain;*/\n\n/*    max-height: 200px;*/\n\n/*}*/\n\n.container {\n    display: flex;\n    box-orient: horizontal;\n    flex-direction: row;\n    box-pack: center;\n    justify-content: center;\n    box-align: center;\n    align-items: center;\n\n}\n\n.image {\n    box-flex: 1;\n    flex: 1 1 auto;\n    text-align: center;\n}\n\nimg {\n    max-width: 100%;\n}\n\n.building-table {\n\n    width: 100%;\n    margin:5px;\n}\n\n.building-table td{\n\n    padding:10px;\n}\n\n.NW-container {\n    width:100%;\n    display: flex;\n}\n\n.container-item {\n    width: 50%;\n    display: inline-block;\n    height: 100%;\n}\n\n.building-table tr:nth-child(even) {background: #414141\n}\n\n.building-table tr:nth-child(odd) {background: #343434\n}\n\n.container-item .mat-form-field {\n    width:100%;\n}\n\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2J1aWxkaW5ncy9zaG93LWJ1aWxkaW5nL3Nob3ctYnVpbGRpbmcuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLGVBQWU7QUFDbkI7O0FBRUEseUJBQXlCOztBQUN6QiwyRkFBMkY7O0FBQzNGLGdDQUFnQzs7QUFDaEMseUJBQXlCOztBQUN6QixJQUFJOztBQUVKO0lBS0ksYUFBYTtJQUliLHNCQUFzQjtJQUN0QixtQkFBbUI7SUFJbkIsZ0JBQWdCO0lBQ2hCLHVCQUF1QjtJQUl2QixpQkFBaUI7SUFDakIsbUJBQW1COztBQUV2Qjs7QUFFQTtJQUdJLFdBQVc7SUFFWCxjQUFjO0lBQ2Qsa0JBQWtCO0FBQ3RCOztBQUVBO0lBQ0ksZUFBZTtBQUNuQjs7QUFHQTs7SUFFSSxXQUFXO0lBQ1gsVUFBVTtBQUNkOztBQUVBOztJQUVJLFlBQVk7QUFDaEI7O0FBR0E7SUFDSSxVQUFVO0lBQ1YsYUFBYTtBQUNqQjs7QUFDQTtJQUNJLFVBQVU7SUFDVixxQkFBcUI7SUFDckIsWUFBWTtBQUNoQjs7QUFDQSxvQ0FBb0M7QUFDcEM7O0FBQ0EsbUNBQW1DO0FBQ25DOztBQUVBO0lBQ0ksVUFBVTtBQUNkIiwiZmlsZSI6InNyYy9hcHAvcm91dGVzL2J1aWxkaW5ncy9zaG93LWJ1aWxkaW5nL3Nob3ctYnVpbGRpbmcuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5idWlsZGluZy1jYXJkIHtcbiAgICBtYXgtd2lkdGg6IDEwMCU7XG59XG5cbi8qLmJ1aWxkaW5nLWNhcmQtaW1hZ2UgeyovXG4vKiAgICBiYWNrZ3JvdW5kLWltYWdlOiB1cmwoJ2h0dHBzOi8vbWF0ZXJpYWwuYW5ndWxhci5pby9hc3NldHMvaW1nL2V4YW1wbGVzL3NoaWJhMS5qcGcnKTsqL1xuLyogICAgYmFja2dyb3VuZC1zaXplOiBjb250YWluOyovXG4vKiAgICBtYXgtaGVpZ2h0OiAyMDBweDsqL1xuLyp9Ki9cblxuLmNvbnRhaW5lciB7XG4gICAgZGlzcGxheTogLXdlYmtpdC1ib3g7XG4gICAgZGlzcGxheTogLW1vei1ib3g7XG4gICAgZGlzcGxheTogLW1zLWZsZXhib3g7XG4gICAgZGlzcGxheTogLXdlYmtpdC1mbGV4O1xuICAgIGRpc3BsYXk6IGZsZXg7XG5cbiAgICAtd2Via2l0LWJveC1vcmllbnQ6IGhvcml6b250YWw7XG4gICAgLW1vei1ib3gtb3JpZW50OiBob3Jpem9udGFsO1xuICAgIGJveC1vcmllbnQ6IGhvcml6b250YWw7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcblxuICAgIC13ZWJraXQtYm94LXBhY2s6IGNlbnRlcjtcbiAgICAtbW96LWJveC1wYWNrOiBjZW50ZXI7XG4gICAgYm94LXBhY2s6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcblxuICAgIC13ZWJraXQtYm94LWFsaWduOiBjZW50ZXI7XG4gICAgLW1vei1ib3gtYWxpZ246IGNlbnRlcjtcbiAgICBib3gtYWxpZ246IGNlbnRlcjtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG59XG5cbi5pbWFnZSB7XG4gICAgLXdlYmtpdC1ib3gtZmxleDogMTtcbiAgICAtbW96LWJveC1mbGV4OiAxO1xuICAgIGJveC1mbGV4OiAxO1xuICAgIC13ZWJraXQtZmxleDogMSAxIGF1dG87XG4gICAgZmxleDogMSAxIGF1dG87XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG5pbWcge1xuICAgIG1heC13aWR0aDogMTAwJTtcbn1cblxuXG4uYnVpbGRpbmctdGFibGUge1xuXG4gICAgd2lkdGg6IDEwMCU7XG4gICAgbWFyZ2luOjVweDtcbn1cblxuLmJ1aWxkaW5nLXRhYmxlIHRke1xuXG4gICAgcGFkZGluZzoxMHB4O1xufVxuXG5cbi5OVy1jb250YWluZXIge1xuICAgIHdpZHRoOjEwMCU7XG4gICAgZGlzcGxheTogZmxleDtcbn1cbi5jb250YWluZXItaXRlbSB7XG4gICAgd2lkdGg6IDUwJTtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgaGVpZ2h0OiAxMDAlO1xufVxuLmJ1aWxkaW5nLXRhYmxlIHRyOm50aC1jaGlsZChldmVuKSB7YmFja2dyb3VuZDogIzQxNDE0MVxufVxuLmJ1aWxkaW5nLXRhYmxlIHRyOm50aC1jaGlsZChvZGQpIHtiYWNrZ3JvdW5kOiAjMzQzNDM0XG59XG5cbi5jb250YWluZXItaXRlbSAubWF0LWZvcm0tZmllbGQge1xuICAgIHdpZHRoOjEwMCU7XG59XG5cbiJdfQ== */");

/***/ }),

/***/ "./src/app/routes/buildings/show-building/show-building.component.ts":
/*!***************************************************************************!*\
  !*** ./src/app/routes/buildings/show-building/show-building.component.ts ***!
  \***************************************************************************/
/*! exports provided: ShowBuildingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShowBuildingComponent", function() { return ShowBuildingComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _add_building_image_add_building_image_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./add-building-image/add-building-image.component */ "./src/app/routes/buildings/show-building/add-building-image/add-building-image.component.ts");
/* harmony import */ var _shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../shared/components/confirm-dialog/confirm-dialog.component */ "./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");









let ShowBuildingComponent = class ShowBuildingComponent {
    constructor(API, route, formBuilder, dialog, snackBar) {
        this.API = API;
        this.route = route;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this.snackBar = snackBar;
        this.id = this.route.snapshot.params.id;
        this.loading = true;
        this.saveLoading = true;
        this.init().then(() => {
            this.formGroup = this.formBuilder.group({
                name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                areas: [null],
                building_code: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].minLength(4), _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].maxLength(4)]],
                address: [null],
                gps: [null],
                keys: [null],
                note: [null],
            });
            this.formGroup.patchValue(this.data.building);
            if (this.data.building.gps_lat && this.data.building.gps_lon) {
                this.formGroup.patchValue({ gps: this.data.building.gps_lat + ', ' + this.data.building.gps_lon });
            }
            this.formGroup.patchValue({ areas: this.data.areas });
        });
    }
    init() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            this.data = yield this.API.getBuilding(this.id);
            this.areas = yield this.API.getAreas();
            this.loading = false;
            this.saveLoading = false;
        });
    }
    ngOnInit() {
    }
    sendForm() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            if (!this.formGroup.valid) {
                return;
            }
            let response;
            this.saveLoading = true;
            var buildingData = this.formGroup.value;
            let tmp = buildingData.gps.split(', ');
            delete buildingData.gps;
            buildingData['gps_lat'] = tmp[0];
            buildingData['gps_lon'] = tmp[1];
            response = yield this.API.saveBuilding(this.id, buildingData);
            if (response.status === 'ok') {
                this.responseMessage = 'Objekt uložen';
            }
            else {
                this.responseMessage = response.message;
            }
            this.saveLoading = false;
        });
    }
    getImage(url) {
        return this.API.getImage(url);
    }
    removeImage(id, index) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const dialogRef = this.dialog.open(_shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_7__["ConfirmDialog"]);
            dialogRef.componentInstance.title = 'Upozornění';
            dialogRef.componentInstance.message = 'Opravdu chcete smazat obrázek?';
            dialogRef.componentInstance.confirmText = 'Ano';
            dialogRef.afterClosed().subscribe((result) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
                if (result === true) {
                    this.data.photos.splice(index, 1);
                    let response;
                    response = yield this.API.removeImage(id);
                }
            }));
        });
    }
    addImage() {
        let dialogRef;
        const data = { buildingId: this.id };
        dialogRef = this.dialog.open(_add_building_image_add_building_image_component__WEBPACK_IMPORTED_MODULE_6__["AddBuildingImageDialog"], {
            width: '25%',
            data
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response !== false) {
                this.init();
            }
        });
    }
    openMap() {
        window.open('https://www.google.com/maps/search/?api=1&query=' + this.formGroup.controls.gps.value, '_blank');
    }
    delete() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const dialogRef = this.dialog.open(_shared_components_confirm_dialog_confirm_dialog_component__WEBPACK_IMPORTED_MODULE_7__["ConfirmDialog"]);
            dialogRef.componentInstance.title = 'Upozornění';
            dialogRef.componentInstance.message = 'Opravdu chcete odstranit objekt?';
            dialogRef.componentInstance.confirmText = 'Ano';
            dialogRef.afterClosed().subscribe((result) => tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
                if (result === true) {
                    const response = yield this.API.deleteBuilding(this.id);
                    if (response.status === 'ok') {
                        this.snackBar.open('✅ Budova byla úspěšně smazána...', 'OK', { duration: 5000 });
                        // Redirect to buildings list
                        setTimeout(() => {
                            window.location.href = '/admin/buildings';
                        }, 2000);
                    }
                    else {
                        this.snackBar.open('⁉️ Něco se pokazilo: ' + response.message, 'OK', { duration: 5000 });
                        this.responseMessage = response.message;
                    }
                }
            }));
        });
    }
};
ShowBuildingComponent.ctorParameters = () => [
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_2__["ApiService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatDialog"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_8__["MatSnackBar"] }
];
ShowBuildingComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-show-building',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./show-building.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/buildings/show-building/show-building.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./show-building.component.css */ "./src/app/routes/buildings/show-building/show-building.component.css")).default]
    })
], ShowBuildingComponent);



/***/ }),

/***/ "./src/app/routes/home/home.component.css":
/*!************************************************!*\
  !*** ./src/app/routes/home/home.component.css ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".dashboard-card, .mat-figure {\n    width:100%;\n    height: 100%;\n    text-align: center;\n    padding:10px;\n}\n.dashboard-full-card {\n    width:100%;\n    height: 100%;\n    text-align: left;\n    padding:10px;\n\n}\n.gray {\n  background-color: #424242;\n}\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvcm91dGVzL2hvbWUvaG9tZS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksVUFBVTtJQUNWLFlBQVk7SUFDWixrQkFBa0I7SUFDbEIsWUFBWTtBQUNoQjtBQUNBO0lBQ0ksVUFBVTtJQUNWLFlBQVk7SUFDWixnQkFBZ0I7SUFDaEIsWUFBWTs7QUFFaEI7QUFFQTtFQUNFLHlCQUF5QjtBQUMzQiIsImZpbGUiOiJzcmMvYXBwL3JvdXRlcy9ob21lL2hvbWUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5kYXNoYm9hcmQtY2FyZCwgLm1hdC1maWd1cmUge1xuICAgIHdpZHRoOjEwMCU7XG4gICAgaGVpZ2h0OiAxMDAlO1xuICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICBwYWRkaW5nOjEwcHg7XG59XG4uZGFzaGJvYXJkLWZ1bGwtY2FyZCB7XG4gICAgd2lkdGg6MTAwJTtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICBwYWRkaW5nOjEwcHg7XG5cbn1cblxuLmdyYXkge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjNDI0MjQyO1xufVxuIl19 */");

/***/ }),

/***/ "./src/app/routes/home/home.component.ts":
/*!***********************************************!*\
  !*** ./src/app/routes/home/home.component.ts ***!
  \***********************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../_services */ "./src/app/_services/index.ts");
/* harmony import */ var _services_api_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../_services/api.service */ "./src/app/_services/api.service.ts");
/* harmony import */ var src_environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! src/environments/environment */ "./src/environments/environment.ts");





let HomeComponent = class HomeComponent {
    constructor(authenticationService, userService, API) {
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.API = API;
        this.users = [];
        this.backupsParsed = [];
        this.loading = true;
        this.creatingBackup = false;
        this.currentUser = this.authenticationService.currentUserValue;
        this.loading = true;
    }
    ngOnInit() {
        this.init();
    }
    init() {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            this.loading = true;
            this.stats = yield this.API.getStats();
            this.backups = yield this.API.getBackupList();
            this.backupsParsed = [];
            for (const b of this.backups) {
                if (!b.startsWith('osesecurity')) {
                    this.creatingBackup = true;
                    continue;
                }
                const ext = b.endsWith('.sql') ? 'sql' : 'zip';
                const parsed = b.split('_');
                let datetime = parsed[2].slice(0, -4).replace(/T(\d{2})-(\d{2})-(\d{2})-(\d{3})Z/, 'T$1:$2:$3.$4Z');
                datetime = new Date(datetime).toLocaleString();
                this.backupsParsed.push({
                    filename: b,
                    ext,
                    type: parsed[1],
                    datetime
                });
            }
            this.loading = false;
        });
    }
    download(filename) {
        return tslib__WEBPACK_IMPORTED_MODULE_0__["__awaiter"](this, void 0, void 0, function* () {
            const token = this.currentUser.token;
            const downloadUrl = `${src_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].apiUrl}/admin/backup/download/files/${filename}/${token}`;
            window.open(downloadUrl, '_blank');
        });
    }
    delete(filename) {
        // Confirm the deletion
        if (confirm('Opravdujete, že chcete smazat zálohu?')) {
            this.API.deleteBackup(filename).then(() => {
                // Refresh the list of backups after deletion
                this.init();
            }).catch((error) => {
                console.error('Error deleting backup:', error);
            });
        }
    }
};
HomeComponent.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_2__["AuthenticationService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_2__["UserService"] },
    { type: _services_api_service__WEBPACK_IMPORTED_MODULE_3__["ApiService"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({ template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/home/home.component.html")).default, styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.css */ "./src/app/routes/home/home.component.css")).default] })
], HomeComponent);



/***/ }),

/***/ "./src/app/routes/home/index.ts":
/*!**************************************!*\
  !*** ./src/app/routes/home/index.ts ***!
  \**************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _home_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./home.component */ "./src/app/routes/home/home.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return _home_component__WEBPACK_IMPORTED_MODULE_1__["HomeComponent"]; });





/***/ }),

/***/ "./src/app/routes/login/index.ts":
/*!***************************************!*\
  !*** ./src/app/routes/login/index.ts ***!
  \***************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _login_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./login.component */ "./src/app/routes/login/login.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return _login_component__WEBPACK_IMPORTED_MODULE_1__["LoginComponent"]; });





/***/ }),

/***/ "./src/app/routes/login/login.component.css":
/*!**************************************************!*\
  !*** ./src/app/routes/login/login.component.css ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("/*html,body{height:100%;margin:0;padding:0;}*/\nbody {\n    background-image: url(https://lh4.googleusercontent.com/-XplyTa1Za-I/VMSgIyAYkHI/AAAAAAAADxM/oL-rD6VP4ts/w1184-h666/Android-Lollipop-wallpapers-Google-Now-Wallpaper-2.png);\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    min-height: 100vh;\n    font-family: 'Roboto', sans-serif;\n\n}\n/*.app-header {*/\n/*    justify-content: space-between;*/\n/*    position: fixed;*/\n/*    top: 0;*/\n/*    left: 0;*/\n/*    right: 0;*/\n/*    z-index: 2;*/\n/*    color:#000;*/\n/*    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);*/\n/*}*/\n.login-wrapper {\n    height: 100%;\n}\n.positronx {\n    text-decoration: none;\n    color: #ffffff;\n}\n.box {\n    position: relative;\n    top: 0;\n    opacity: 1;\n    float: left;\n    padding: 60px 50px 40px 50px;\n    width: 100%;\n    background: rgba(77, 77, 77, 0.48);\n    border-radius: 10px;\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    z-index: 5;\n    max-width: 330px;\n}\n.box.back {\n    transform: scale(.95);\n    -webkit-transform: scale(.95);\n    -ms-transform: scale(.95);\n    top: -20px;\n    opacity: .8;\n    z-index: -1;\n}\n/*.box:before {*/\n/*    content: \"\";*/\n/*    width: 100%;*/\n/*    height: 30px;*/\n/*    border-radius: 10px;*/\n/*    position: absolute;*/\n/*    top: -10px;*/\n/*    background: rgba(255, 255, 255, .6);*/\n/*    left: 0;*/\n/*    transform: scale(.95);*/\n/*    -webkit-transform: scale(.95);*/\n/*    -ms-transform: scale(.95);*/\n/*    z-index: -1;*/\n/*}*/\n.login-wrapper .example-form {\n    min-width: 100%;\n    max-width: 300px;\n    width: 100%;\n    color:#000;\n}\n.login-wrapper .example-full-width, .login-wrapper .btn-block {\n    width: 100%;\n    color:#000;\n    padding:5px;\n\n}\n.login-wrapper mat-card-header {\n    text-align: center;\n    width: 100%;\n    display: block;\n    font-weight: 700;\n    color:#000;\n}\n.login-wrapper mat-card-header mat-card-title {\n    font-size: 30px;\n    margin: 0;\n    color:#FFF7FA;\n}\n.login-wrapper .mat-card {\n    padding: 40px 70px 50px;\n}\n.login-wrapper .mat-stroked-button {\n    border: 1px solid currentColor;\n    line-height: 54px;\n    background: #FFF7FA;\n}\n.login-wrapper .mat-form-field-appearance-legacy .mat-form-field-infix {\n    padding: 0.8375em 0;\n}\n.mat-form-field-label {\n    color: rgba(0, 0, 0, 0.7) !important;\n}\n.example-full-width, .mat-form-field-infix, .mat-form-field-infix input, .mat-form-field-label-wrapper{\n    color:#000 !important;\n}\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/routes/login/login.component.ts":
/*!*************************************************!*\
  !*** ./src/app/routes/login/login.component.ts ***!
  \*************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../_services */ "./src/app/_services/index.ts");






let LoginComponent = class LoginComponent {
    constructor(formBuilder, route, router, authenticationService, alertService) {
        this.formBuilder = formBuilder;
        this.route = route;
        this.router = router;
        this.authenticationService = authenticationService;
        this.alertService = alertService;
        this.loading = false;
        this.submitted = false;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }
    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            password: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required]
        });
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }
    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    onSubmit() {
        this.submitted = true;
        // reset alerts on submit
        this.alertService.clear();
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }
        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["first"])())
            .subscribe(data => {
            this.router.navigate([this.returnUrl]);
        }, error => {
            this.alertService.error(error);
            this.loading = false;
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AlertService"] }
];
LoginComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/login/login.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./login.component.css */ "./src/app/routes/login/login.component.css")).default]
    })
], LoginComponent);



/***/ }),

/***/ "./src/app/routes/register/index.ts":
/*!******************************************!*\
  !*** ./src/app/routes/register/index.ts ***!
  \******************************************/
/*! exports provided: RegisterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _register_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./register.component */ "./src/app/routes/register/register.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegisterComponent", function() { return _register_component__WEBPACK_IMPORTED_MODULE_1__["RegisterComponent"]; });





/***/ }),

/***/ "./src/app/routes/register/register.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/routes/register/register.component.ts ***!
  \*******************************************************/
/*! exports provided: RegisterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RegisterComponent", function() { return RegisterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../_services */ "./src/app/_services/index.ts");






let RegisterComponent = class RegisterComponent {
    constructor(formBuilder, router, authenticationService, userService, alertService) {
        this.formBuilder = formBuilder;
        this.router = router;
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.alertService = alertService;
        this.loading = false;
        this.submitted = false;
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(['/']);
        }
    }
    ngOnInit() {
        this.registerForm = this.formBuilder.group({
            firstName: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            lastName: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            username: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required],
            password: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_3__["Validators"].minLength(6)]]
        });
    }
    // convenience getter for easy access to form fields
    get f() { return this.registerForm.controls; }
    onSubmit() {
        this.submitted = true;
        // reset alerts on submit
        this.alertService.clear();
        // stop here if form is invalid
        if (this.registerForm.invalid) {
            return;
        }
        this.loading = true;
        this.userService.register(this.registerForm.value)
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["first"])())
            .subscribe(data => {
            this.alertService.success('Registration successful', true);
            this.router.navigate(['/login']);
        }, error => {
            this.alertService.error(error);
            this.loading = false;
        });
    }
};
RegisterComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_3__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AuthenticationService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["UserService"] },
    { type: _services__WEBPACK_IMPORTED_MODULE_5__["AlertService"] }
];
RegisterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({ template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./register.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/routes/register/register.component.html")).default })
], RegisterComponent);



/***/ }),

/***/ "./src/app/routing.module.ts":
/*!***********************************!*\
  !*** ./src/app/routing.module.ts ***!
  \***********************************/
/*! exports provided: RoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RoutingModule", function() { return RoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_components_notfound_notfound_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./shared/components/notfound/notfound.component */ "./src/app/shared/components/notfound/notfound.component.ts");
/* harmony import */ var _routes_home__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./routes/home */ "./src/app/routes/home/index.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./_helpers */ "./src/app/_helpers/index.ts");
/* harmony import */ var _routes_login__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./routes/login */ "./src/app/routes/login/index.ts");







const routes = [
    { path: 'not-found', component: _shared_components_notfound_notfound_component__WEBPACK_IMPORTED_MODULE_3__["NotfoundComponent"] },
    { path: '', component: _routes_home__WEBPACK_IMPORTED_MODULE_4__["HomeComponent"], canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_5__["AuthGuard"]] },
    { path: 'login', component: _routes_login__WEBPACK_IMPORTED_MODULE_6__["LoginComponent"] },
    {
        path: 'areas',
        canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_5__["AuthGuard"]],
        loadChildren: './routes/areas/areas.module#AreasModule'
    },
    {
        path: 'buildings',
        canActivate: [_helpers__WEBPACK_IMPORTED_MODULE_5__["AuthGuard"]],
        loadChildren: './routes/buildings/buildings.module#BuildingsModule'
    },
    { path: '**', redirectTo: 'not-found' }
];
let RoutingModule = class RoutingModule {
};
RoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], RoutingModule);



/***/ }),

/***/ "./src/app/shared/components/alert/alert.component.ts":
/*!************************************************************!*\
  !*** ./src/app/shared/components/alert/alert.component.ts ***!
  \************************************************************/
/*! exports provided: AlertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return AlertComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../_services */ "./src/app/_services/index.ts");



let AlertComponent = class AlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
    }
    ngOnInit() {
        this.subscription = this.alertService.getAlert()
            .subscribe(message => {
            switch (message && message.type) {
                case 'success':
                    message.cssClass = 'alert alert-success';
                    break;
                case 'error':
                    message.cssClass = 'alert alert-danger';
                    break;
            }
            this.message = message;
        });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
};
AlertComponent.ctorParameters = () => [
    { type: _services__WEBPACK_IMPORTED_MODULE_2__["AlertService"] }
];
AlertComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'alert',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./alert.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/alert/alert.component.html")).default
    })
], AlertComponent);



/***/ }),

/***/ "./src/app/shared/components/alert/index.ts":
/*!**************************************************!*\
  !*** ./src/app/shared/components/alert/index.ts ***!
  \**************************************************/
/*! exports provided: AlertComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _alert_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./alert.component */ "./src/app/shared/components/alert/alert.component.ts");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AlertComponent", function() { return _alert_component__WEBPACK_IMPORTED_MODULE_1__["AlertComponent"]; });





/***/ }),

/***/ "./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts":
/*!******************************************************************************!*\
  !*** ./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts ***!
  \******************************************************************************/
/*! exports provided: ConfirmDialog */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfirmDialog", function() { return ConfirmDialog; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");



let ConfirmDialog = class ConfirmDialog {
    constructor(dialogRef) {
        this.dialogRef = dialogRef;
    }
};
ConfirmDialog.ctorParameters = () => [
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_2__["MatDialogRef"] }
];
ConfirmDialog = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-delete-dialog',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./confirm-dialog.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/confirm-dialog/confirm-dialog.component.html")).default
    })
], ConfirmDialog);



/***/ }),

/***/ "./src/app/shared/components/notfound/notfound.component.scss":
/*!********************************************************************!*\
  !*** ./src/app/shared/components/notfound/notfound.component.scss ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".not-found-wrapper {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n}\n.not-found-wrapper .mat-button {\n  margin-top: 3em;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9hZGFtc21pZC9Xb3JrYm94L29zZS1hZG1pbi9zcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL25vdGZvdW5kL25vdGZvdW5kLmNvbXBvbmVudC5zY3NzIiwic3JjL2FwcC9zaGFyZWQvY29tcG9uZW50cy9ub3Rmb3VuZC9ub3Rmb3VuZC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLG1CQUFBO0VBQ0EsYUFBQTtFQUNBLHNCQUFBO0FDQ0Y7QURDRTtFQUNFLGVBQUE7QUNDSiIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL25vdGZvdW5kL25vdGZvdW5kLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm5vdC1mb3VuZC13cmFwcGVyIHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcblxuICAubWF0LWJ1dHRvbiB7XG4gICAgbWFyZ2luLXRvcDogM2VtO1xuICB9XG59IiwiLm5vdC1mb3VuZC13cmFwcGVyIHtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZGlzcGxheTogZmxleDtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbn1cbi5ub3QtZm91bmQtd3JhcHBlciAubWF0LWJ1dHRvbiB7XG4gIG1hcmdpbi10b3A6IDNlbTtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/shared/components/notfound/notfound.component.ts":
/*!******************************************************************!*\
  !*** ./src/app/shared/components/notfound/notfound.component.ts ***!
  \******************************************************************/
/*! exports provided: NotfoundComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotfoundComponent", function() { return NotfoundComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let NotfoundComponent = class NotfoundComponent {
    constructor(router) {
        this.router = router;
    }
    ngOnInit() {
    }
    goBack() {
        this.router.navigate(['/']);
    }
};
NotfoundComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
NotfoundComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-notfound',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./notfound.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/notfound/notfound.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./notfound.component.scss */ "./src/app/shared/components/notfound/notfound.component.scss")).default]
    })
], NotfoundComponent);



/***/ }),

/***/ "./src/app/shared/shared.module.ts":
/*!*****************************************!*\
  !*** ./src/app/shared/shared.module.ts ***!
  \*****************************************/
/*! exports provided: SharedModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharedModule", function() { return SharedModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _components_notfound_notfound_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/notfound/notfound.component */ "./src/app/shared/components/notfound/notfound.component.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _components_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/alert */ "./src/app/shared/components/alert/index.ts");








let SharedModule = class SharedModule {
};
SharedModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["ReactiveFormsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatIconModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_6__["MatButtonModule"]
        ],
        declarations: [
            _components_notfound_notfound_component__WEBPACK_IMPORTED_MODULE_5__["NotfoundComponent"],
            _components_alert__WEBPACK_IMPORTED_MODULE_7__["AlertComponent"]
        ],
        exports: [],
        entryComponents: [],
    })
], SharedModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false,
    apiUrl: 'https://osesecurity.net-wings.cz:8080'
    //apiUrl: 'https://osesecurity.net-wings.cz:8181'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/adamsmid/Workbox/ose-admin/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map